import React, { Component, useState, useEffect } from 'react';
import TopNav from '../components/TopNav';
import MessageModal from './modal/MessageModal';
import ConfirmModal from './modal/ConfirmModal';
import MenuItemModal from './modal/MenuItemModal';
import Axios from 'axios';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { TextInput, HiddenInput, SwitchInput } from '../components/widget/input/Input';
import { pageReload } from '../util/PageReload';
import LoginModal from './modal/LoginModal';
import moment from 'moment';
import 'rc-time-picker/assets/index.css';
import { TableSessionType } from '../app/Common/Enum/TableSessionType';
import OrderHandler from '../app/User/Handler/OrderHandler';
import Navigator from '../app/User/Navigator/Navigator';
import { Bill } from '../Model/Bill';
import DeliveryDetailRepository from '../components/repository/DeliveryDetailRepository';
import ReactHelper from '../util/ReactHelper';
import Formatter from '../util/Formatter';
import DatePicker from "react-datepicker";
import AppData from './../Model/AppData';

import "react-datepicker/dist/react-datepicker.css";
import AppSettingRepository from '../components/repository/AppSettingRepository';

import './PickupInformation.scss';
import TimePickerModal from './modal/TimePickerModal';
import WorkingHourHandler, { WorkingHourType } from '../app/User/Handler/WorkingHourHandler';
import { handleAjaxError } from '../util/api';
import { PromoCodeType } from '../app/Common/Enum/PromoCodeType';
import { addDays } from "date-fns";
import PromoCodeListModal from './modal/PromoCodeListModal';
import { PulseLoader } from 'halogenium';
import { TableType } from '../components/merchant/Enum/TableType';
import SelectOneFromManyModal from './modal/SelectOneFromManyModal';
import PickupOrderMode, { PickupOrderModeChangeModeMethod } from '../Model/PickupOrderMode';
import CalculationHelper from './../components/admin/table_session/helper/CalculationHelper';
import TableSearchComponent from '../components/TableSearchComponent';
import Table from '../Model/Table';
import SelectedVariationListing from '../app/User/Order/SelectedVariationListing';
import SelectedSideDishListing from '../app/User/Order/SelectedSideDishListing';
import { OutOfStockHint } from './Order';
import InventoryHelper from './Helper/InventoryHelper';
import MerchantSettingKey from "../app/Common/Enum/MerchantSettingKey";

const DEFAULT_DELIVERY_PROCESSING_FEE = 0
const DEFAULT_DELIVERY_COST_MERCHANT_COVER = 0

/**
 * Offset of business start time to do checking.
 * Eg:
 * Business hour = 8:00am - 11:00am,
 *
 * Then in some checking regarding allow/disallow ASAP, we will do
 * (8:00am - BUSINESS_OPEN_OFFSET) < Now < 11:00am
 */
const BUSINESS_OPEN_OFFSET = 5

/**
 * Different modes to check if given time is within
 * working hour
 */
const WorkingHourCheckingType = {
    MINIMUM_ORDER_TIME  : "MINIMUM_ORDER_TIME",
    START_TIME          : "START_TIME",
}

const formatTime = (momentTime) => {
    return momentTime.format("hh:mm a")
}

function PickupInformationCalculator(component) {
    this.component = component
    this.getTotalPrice = () => {
        const billDetail = this.getBillDetail()
        return billDetail.total || 0.0
    }

    this.getBillDetail = () => {
        let app = component.props.app
        let orders = component.props.app.state.orders || []
        let tableSession = component.props.app.state.current_session || {}

        let gotTax = app.state.merchant.tax_no != null
        let scPercent = component.getServiceChargePercent() // app.getMerchantSettingValue('service_charge')
        let extraSCstart = app.getMerchantSettingValue('extra_service_charge_start')
        let extraSCend = app.getMerchantSettingValue('extra_service_charge_end')
        let extraSCGetName = app.getMerchantSettingValue('extra_service_charge_name')
        let extraSCName = extraSCGetName != "" ? extraSCGetName : "Extra Surcharge"
        let extraSCPercent = app.getMerchantSettingValue('extra_service_charge_value')
        let pickupTime = tableSession.pickup_time != null ? tableSession.pickup_time : component.state.pickupTime.toDate()
        let extraSCValue = (extraSCPercent == null || extraSCPercent == 0) ? 0 : (extraSCPercent / 100.00);
        let serviceCharge = (scPercent == null || scPercent == 0) ? 0 : (scPercent / 100.00);
        let deliveryCharge = component.isDelivery() && component.state.deliveryDetail && component.state.deliveryDetail.deliveryCharge || 0
        let extraCharge = 0
        let extraChargeData = tableSession?.extra_data?.extra_charge
        if (extraChargeData) {
            extraCharge = CalculationHelper.round2dp(parseFloat(extraChargeData.value))
        }
        let roundTo = app.state.merchant.bill_round_to_nearest
        let a = Bill.calculateBillDetailsForOrder({
            orders, isHasTax: gotTax, pickupTime, serviceCharge, extraSCstart, extraSCend, extraSCName, extraSCValue, deliveryCharge, promoCode: tableSession.promo_code_data, extraCharge, roundTo
        })
        return a
    }
}

function ItemPrice({price, currencyName}) {
    let _price = parseFloat(price)
    let isNegative = _price < 0
    let className = isNegative ? "text-danger" : ""
    return <div className={`pull-right ${className}`}>{isNegative && "- "} {currencyName}&nbsp; <span style={{display: "inline-block", textAlign: "right", minWidth:"70px"}}>{Math.abs(_price).toFixed(2)}</span></div>
}

function OrderHeader({ order, currencyName, customOrderItem}) {
    let [ quantity, desc, price ] = customOrderItem ?
        [customOrderItem.quantity || 1, customOrderItem.desc || "", customOrderItem.price || 0] :
        [order.quantity, order.desc, order.order_total]
    return <div className="mt-3" style={{ fontSize: "20px", fontWeight: "bold" }}>
        {quantity + "x " + desc}
        <ItemPrice price={price} currencyName={currencyName}/>
    </div>

    {/* <div className="pull-right">{"RM " + (order.order_total * 1).toFixed(2)}</div> */}
}

function scrollToTargetAdjusted(elementId){
    console.log("scroll")
    const element = document.getElementById(elementId)
    const minimumVisibleHeight = 61 + 20 // Need to at least scroll more than navbar (61px + some offset) to be visible
    const elementPosition = element.getBoundingClientRect().top;
    // const offsetPosition = elementPosition - headerOffset;

    const currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop

    if (elementPosition < minimumVisibleHeight) {
    // if (currentScrollTop < minimumVisibleHeight) {
        console.log("need scroll")
        window.scrollTo({
            top: element.offsetTop - minimumVisibleHeight,
            behavior: "smooth"
       });
    }

    // window.scrollTo({
    //      top: offsetPosition,
    //      behavior: "smooth"
    // });
}

const colorDanger = "rgb(191, 83, 41)"
let permissionRequested = false
export default class PickupInformation extends Component {
    constructor(props) {
        super(props)
        this.inventoryHelper = new InventoryHelper()
        this.billCalculator = new PickupInformationCalculator(this)
        this.state = {
            contact: {
                name: '',
                phone_number: '',
                email: '',
                firebase_uid: ''
            },
            selectedPromoCode: null,
            showPromoModal: null,
            pickupTime: this.getPickupTime(),
            isFirebaseSignedIn: false,
            isFirebaseLoaded: false,

            // deliveryDetail: {
            //     delivery_charge: 11
            // },
            deliveryDetail: OrderHandler.getDeliveryDetail(),

            // Set to true after user click Confirm and Pay, and we
            // get success respond from server. Then this flag shall
            // to compared with current_session.is_pickup_confirmed. Only when both
            // flag passed, we redirect to payment page. Redirect to next page
            // too soon before Firebase sync completed will cause deliveryCharge = 0
            // to be submitted to payment gateway price calculation
            isRedirectToPaymentPage: false,
            chosenDate: new Date(),
            datePickerIsOpen: false,
            deliveryInfo: {
                reason: "",
                description: "",
            },
            isOverValueFreeDelivery: false,

            // Flag to know if user click Confirm and Pay
            isConfirmAndPay: false,

            // Set to true to indicate user want to process order ASAP
            // Default is false, but after ready, process ONE TIME to see if
            // eligible for ASAP, set to ASAP if can.
            isAsap: false,

            appSettings: [],
            defpickupTime: null,
            editingMenuItem: null,
            editingOrder: null,
            counterRedirect: 0,

            pickupOrderMode: null,
            disableRemark: false,

            // By default do not allow to show check payment button as we have
            // background API checking for payment. After sometime where background API
            // most probably should complete (or error) and UI still not updated (no confirmed payment),
            // then we show CheckPayment button to allow user to manual trigger check payment again
            allowShowCheckPaymentButton: false,

            // After user click check payment, set a timer to prevent user spamming
            isCheckingPayment: false,
            outOfStockItems: this.inventoryHelper.getOutOfStockInfo(this.getDraftOrders()),

            askUserNeedUtensil: this.props.app.getMerchantSettingValue(MerchantSettingKey.ASK_USER_NEED_UTENSILS) == 1,
            isNeedUtensil: false,
        }
        this.confirmModalRef = React.createRef()
        this.confirmNewModalRef = React.createRef()
        this.paymentMethodModalRef = React.createRef()
        this.datePickerRef = React.createRef()
        this.cancelItemOrder = this.cancelItemOrder.bind(this)

        if (paymentError) {
            this.error = paymentError
            paymentError = ''
        }

        this.deliveryDetailRepositoryCallbackKey = "PickupInformation"
        this.AppSettingRepositoryKey = "AppSettingRepositoryKey"
    }

    initPickupOrderMode = () => {
        const setDefault = () => {
            const pickupOrderModes = this.getPickupOrderModes()
            if (pickupOrderModes.length > 1) {
                this.setState({
                    pickupOrderMode: pickupOrderModes[0]
                })
            }
        }
        if (this.state.pickupOrderMode == null) {
            if (window.table_session_id) {
                if (this.props.app.state.current_session) {
                    if (this.props.app.state.current_session.order_mode) {
                        this.setState({
                            pickupOrderMode: this.props.app.state.current_session.order_mode,
                        })
                        return
                    }
                    else {
                        setDefault()
                    }
                }
            }
            else {
                setDefault()
            }
        }

        // On order_mode updated
        else if (this.state.pickupOrderMode && this.props.app.state.current_session && this.props.app.state.current_session.order_mode &&
            (this.state.pickupOrderMode != this.props.app.state.current_session.order_mode)) {
            this.setState({
                pickupOrderMode: this.props.app.state.current_session.order_mode,
            })
        }
    }

    getPickupTime = () => {
        const bufferTime = this.getBufferTime()
        let time = moment().add(bufferTime, 'minute')

        if (this.isPreOrderOnly()) {
            time.add(1, 'day')
        }
        return this.roundToNearest15Minute(time)
    }
    showEditDialog(order) {
        console.log("Yes")
        let orderItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)
        this.setState({
            editingMenuItem: orderItem,
            editingOrder: order
        })
    }
    roundToNearest15Minute = (time, max) => {
        let minute = time.minutes()
        var intervals = Math.floor(minute / 15);
        if (minute % 15 != 0) {
            intervals++;
        }

        if (intervals == 4) {
            time.add(1, 'hours');
            intervals = 0;
        }
        time.minutes(intervals * 15);
        time.seconds(0);
        if (max) {
            while (time.isAfter(max, 'minute')) {
                time.add(-15, 'minute')
            }
        }
        return time
    }

    getSettingValue = (key, defaultValue) => {
        let value = this.props.app.getMerchantSettingValue(key)
        if (value == null) {
            return defaultValue
        }
        return parseFloat(value) || 0   // Return 0 if unable to parse value
    }
    getBufferTime() {
        const pickupBufferTime = this.getSettingValue('pickup_buffer_time', 15)
        const deliveryBufferTime = this.getSettingValue('delivery_buffer_time', 45)
        return this.isDelivery() ? deliveryBufferTime : pickupBufferTime
    }

    isPeakHour = () => {
        return this.state.isPeakHour
    }
    getPeakHours = () => {
        return AppData.getPeakHours(this.state.appSettings)
    }

    handlePeakHour = () => {
        const { pickupTime } = this.state
        this.setState({ isPeakHour: AppData.isPeakHour(this.state.appSettings, pickupTime) })
    }
    componentDidMount() {
        this.props.app.loadTableIfNull(this.props.tableId)
        this.initPickupOrderMode()
        this.handleDPickupDisableRemark()

        this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
            (user) => {
                //console.log(user)
            })
        // this.ui = new firebaseui.auth.AuthUI(firebase.auth())
        this.loadFirebase()

        // Auto show login form after a small delay if not logged in
        if (!customerId) {
            setTimeout(this.showLoginModal, 600)
        }
        //calculate delivery cost
        this.calculateDeliveryCost(this.state.deliveryDetail)

        AppSettingRepository.getInstance().loadAll((appSettings) => {
            this.setState({appSettings}, this.handlePeakHour)
        }, this.AppSettingRepositoryKey, this)

        $(document).off('promocodeselected').on('promocodeselected', (e, promoCode) => {
            this.setState({
                selectedPromoCode: promoCode
            }, () => {
                $(document).trigger('clickvalidatepromocodebutton')
            })
        })

        setTimeout(() => {
            this.setState({
                allowShowCheckPaymentButton: true
            })
        }, 5000);
    }

    getMerchantSettingValue = (key, defaultValue) => {
        let value = this.props.app.getMerchantSettingValue(key)
        if (value == null || value == '') {
            return defaultValue
        }
        return parseFloat(value) || 0   // Return 0 if unable to parse value
    }

    getPeakHourSurcharge = () => {
        return parseFloat(this.getMerchantSettingValue('peak_hour_surcharge', 2))
    }

    calculateDeliveryCost = (deliveryDetail) => {
        let deliveryInfo = this.state.deliveryInfo
        if (deliveryDetail == null) { //Pick up
            this.getPreOrderReady(deliveryDetail, deliveryInfo)
            return;
        }

        // if (this.props.app.isMerchantHasFeature('is_admin_manual_perform_delivery_booking')) {
        // }
        // deliveryDetail.peakHourSurcharge = this.isPeakHour() ? this.getPeakHourSurcharge() : 0
        // Peak hour charge already included in calculate price API response

        // Check eligible for free delivery or no
        let orderTotal = this.getDraftOrders().reduce((total, order) => {
            total += parseFloat(order.order_total)
            return total
        }, 0.00)

        let freeDeliveryForValue = parseFloat(this.props.app.getMerchantSettingValue('delivery_free_for_value') || 9999)
        this.state.isOverValueFreeDelivery = orderTotal >= freeDeliveryForValue ? true : false


        this.setState({multiTierDeliveryDiscount: null})
        deliveryInfo.reason = null
        deliveryInfo.description = null
        if (this.isMultiTierDeliveryDiscount()) {
            const currentDeliveryPrice = deliveryDetail.baseCharge + deliveryDetail.processingFee
            const { deliveryCharge, merchantCoverFee, reason, coverCostReason, multiTierDeliveryDiscount  } = this.calculateMultiTierDeliveryDiscount(orderTotal, currentDeliveryPrice)

            // Have discount value, update delivery fee, cover cost, and the reason
            if (merchantCoverFee) {
                deliveryInfo.reason = reason
                deliveryDetail.deliveryCharge = deliveryCharge
                deliveryDetail.merchantCoverFee = 0
                deliveryDetail.merchant_cover_cost_reason = coverCostReason
                if (!this.props.app.isMerchantHasFeature('is_allow_merchant_use_own_delivery_team')) {
                    deliveryDetail.merchantCoverFee = merchantCoverFee
                }
            }

            // Has next tier, prepare the hint
            if (multiTierDeliveryDiscount && multiTierDeliveryDiscount.nextTier && multiTierDeliveryDiscount.nextTier.description) {
                deliveryInfo.description = multiTierDeliveryDiscount.nextTier.description
            }
            this.setState({multiTierDeliveryDiscount})
        }
        else if (this.state.isOverValueFreeDelivery) { //Free delivery
            deliveryInfo.reason = lang.purchase_over + " "+this.props.app.state.currencyName+" " + freeDeliveryForValue;

            //In case there is free delivery, we shall collect base price + processing fee from merchant
            deliveryDetail.deliveryCharge = 0
            deliveryDetail.merchantCoverFee = 0
            if (!this.props.app.isMerchantHasFeature('is_allow_merchant_use_own_delivery_team')) {
                deliveryDetail.merchantCoverFee = deliveryDetail.baseCharge + deliveryDetail.processingFee
            }
        }
        else if(this.props.app.isMerchantHasFeature('is_allow_merchant_use_own_delivery_team')) {
            let diff = freeDeliveryForValue - orderTotal
            deliveryInfo.description = (diff <= 10 && diff > 0) ? lang.push_sales_to_go.replace("<br>", (diff).toFixed(2)) : ""

            let merchantCoverFee = 0;

            //Reset to normal
            const totalDeliveryCharge = deliveryDetail.baseCharge + deliveryDetail.processingFee
            if (totalDeliveryCharge > merchantCoverFee) {
                deliveryDetail.deliveryCharge = totalDeliveryCharge - merchantCoverFee
                deliveryDetail.merchantCoverFee = merchantCoverFee
            }
            else {
                // Oops, delivery charge is cheaper than what merchant willing to cover
                deliveryDetail.deliveryCharge = 0
                deliveryDetail.merchantCoverFee = totalDeliveryCharge
            }
        }
        else {
            let diff = freeDeliveryForValue - orderTotal
            deliveryInfo.description = (diff <= 10 && diff > 0) ? lang.push_sales_to_go.replace("<br>", (diff).toFixed(2)) : ""

            let merchantCoverFee = parseFloat(this.props.app.getMerchantSettingValue('delivery_cost_merchant_cover') || 0)

            //Reset to normal
            const totalDeliveryCharge = deliveryDetail.baseCharge + deliveryDetail.processingFee
            if (totalDeliveryCharge > merchantCoverFee) {
                deliveryDetail.deliveryCharge = totalDeliveryCharge - merchantCoverFee
                deliveryDetail.merchantCoverFee = merchantCoverFee
            }
            else {
                // Oops, delivery charge is cheaper than what merchant willing to cover
                deliveryDetail.deliveryCharge = 0
                deliveryDetail.merchantCoverFee = totalDeliveryCharge
            }
        }
        this.getPreOrderReady(deliveryDetail, deliveryInfo)
    }
    getMultiTierDiscountSetting = () => {
        let multiTierDeliveryDiscount = this.props.app.getMerchantSettingValue('multi_tier_delivery_discount')
        if (multiTierDeliveryDiscount && multiTierDeliveryDiscount != "") {
            try {
                return JSON.parse(multiTierDeliveryDiscount)
            }
            catch (e) {
                console.log("Invalid multi_tier_delivery_discount value")
            }
        }
        return []
    }
    isMultiTierDeliveryDiscount = () => {
        return this.getMultiTierDiscountSetting().length > 0
    }
    calculateMultiTierDeliveryDiscount = (orderTotal, currentDeliveryPrice) => {
        const deliveryDiscountTier = this.getMultiTierDiscountSetting()

        // Reverse loop to match highest threshold
        const count = deliveryDiscountTier.length
        let discountTierToApply = null
        let multiTierDeliveryDiscount = {
            currentTier: null,
            nextTier: null,
        }
        let nextTier = null
        for (let i = count - 1; i >= 0; i--) {
            let discountTier = deliveryDiscountTier[i]
            discountTier.threshold = parseFloat(discountTier.threshold)

            let threshold = discountTier.threshold
            if (orderTotal >= threshold) {
                discountTierToApply = discountTier
                break;
            }

            // This tier do not apply, temporarily take note so that
            // if next 'lower' tier is applicable, then this current tier
            // shall be the 'next higher' tier. This is just for UI purposes
            nextTier = discountTier
        }

        // Apply discount, make sure do not discount to negative value
        let discountValue = discountTierToApply ? parseFloat(discountTierToApply.discount || 0) : 0

        let merchantCoverFee = discountValue > currentDeliveryPrice ? currentDeliveryPrice : discountValue
        const deliveryCharge = currentDeliveryPrice - merchantCoverFee
        let reason = ""
        let coverCostReason = null
        let reasonTemplate = lang.entitled_delivery_discount
        let nextTierTemplate = lang.buy_more_for_delivery_discount
        if (discountTierToApply && merchantCoverFee > 0) {
            coverCostReason = `Delivery fee discount, ${currentDeliveryPrice.toFixed(2)} -> ${deliveryCharge.toFixed(2)}`
            const discountAmount = this.toCurrency(merchantCoverFee)
            reason = reasonTemplate.replace('%price%', discountAmount)

            // Set 'multiTierDeliveryDiscount' only when we have actual value to discount
            // Add other calculated values for UI display purpose
            multiTierDeliveryDiscount.currentTier = discountTierToApply
            multiTierDeliveryDiscount.originalDeliveryPrice = currentDeliveryPrice
        }

        if (nextTier) {
            multiTierDeliveryDiscount.nextTier = nextTier

            // Extra purchase value needed to reach next tier
            nextTier.markupPriceNeeded = nextTier.threshold - orderTotal

            // Calculate discount amount of next tier. Similar logic, make sure
            // do not get negative delivery price
            nextTier.nextTierMaxDiscount = nextTier.discount > currentDeliveryPrice ? currentDeliveryPrice : nextTier.discount
            nextTier.description = nextTierTemplate.replace('%extra%', this.toCurrency(nextTier.markupPriceNeeded)).replace('%discount%', this.toCurrency(nextTier.nextTierMaxDiscount))
        }
        return { deliveryCharge, merchantCoverFee, reason, coverCostReason, multiTierDeliveryDiscount }
    }

    toCurrency = (amount) => {
        return `${this.props.currencyName} ${parseFloat(amount).toFixed(2)}`
    }

    isPreOrderOnly = () => {
        return this.isDelivery() && (!!parseInt(this.props.app.getMerchantSettingValue('preorder_only')) || false)
    }

    getPreOrderReady = (deliveryDetail, deliveryInfo) => {
        //Check whether is Preorder only and apply shipping incentive by merchant
        let preorderOnly = this.isPreOrderOnly() // (!!parseInt(this.props.app.getMerchantSettingValue('preorder_only')) || false)
        if (preorderOnly) {
            let pickupTime = null

            // User selected today, change it to tomorrow
            if (this.state.pickupTime.isSame(moment(), 'day')) {
                pickupTime = moment(this.state.pickupTime).add(1, 'day')
            }
            let toSetState = {
                deliveryDetail: deliveryDetail,
                deliveryInfo: deliveryInfo,
            }
            if (pickupTime) {
                toSetState.pickupTime = pickupTime
            }
            this.setState(toSetState)
        }
        else {
            this.setState({
                deliveryDetail: deliveryDetail,
                deliveryInfo: deliveryInfo,
            })
        }
    }

    handleChange = date => {
        const pickupTime = moment(this.state.pickupTime)
        const selectedDate = moment(date)
        pickupTime.set({
            year: selectedDate.get('year'),
            month: selectedDate.get('month'),
            date: selectedDate.get('date'),
        })

        this.setState({
            chosenDate: date,
            pickupTime: pickupTime,
            defpickupTime: pickupTime.format("hh:mm a"),
        }, this.checkPickupTimeWithinWorkingHour);
    };

    openDatePicker = (e) => {
        this.datePickerRef.current && this.datePickerRef.current.setOpen(!this.state.datePickerIsOpen)
        this.setState({
            datePickerIsOpen: !this.state.datePickerIsOpen,
        });
    };

    requestNotificationPermission = () => {
        if ('Notification' in window && firebase.messaging.isSupported()) {
            const getToken = () => {
                const messaging = firebase.messaging();
                messaging
                    .requestPermission()
                    .then(() => {
                        // get the token in the form of promise
                        return messaging.getToken()
                    })
                    .then((token) => {
                        this.sendTokenToServer(token)
                    })
                    .catch(function (err) {
                        console.log("Unable to get permission to notify.", err);
                    });

                this.monitorRefreshToken()
            }

            if (Notification.permission === "granted") {
                getToken()
            }
            else if (Notification.permission === "default") {
                if (confirm((lang.allow_web_push || "Allow Orderlah to send push notification to you when order is ready?"))) {
                    getToken()
                }
            }
        }
    }

    sendTokenToServer = (token) => {
        Axios.post(`/customer/update_fcm_token`, {
            fcm_token: token,
        }).then((res) => {

        })
        .catch((error) => {
            console.log(error)
        }).finally(() => {

        })
    }

    monitorRefreshToken = () => {
        // Callback fired if Instance ID token is updated.
        messaging.onTokenRefresh(() => {
            messaging.getToken().then((refreshedToken) => {
                console.log('Token refreshed.');
                // Send Instance ID token to app server.
                sendTokenToServer(refreshedToken);

            }).catch((err) => {
                console.log('Unable to retrieve refreshed token ', err);
            });
        });
    }

    isAllowAsap = () => {
        const merchant = this.props.app.state.merchant
        if (merchant) {
            if (this.isDelivery()) {
                return merchant.is_delivery_allow_asap
            }
            else {
                if (this.isPickupAsapOrderOnly()) {
                    return true
                }
                // Pickup order
                return merchant.is_pickup_allow_asap
            }
        }
        return false
    }

    adjustPickupTimeForWorkingHour = () => {
        let now = moment()
        let adjustedPickupTime = moment(this.state.pickupTime)
        let workingHour = this.getWorkingHour(this.state.pickupTime)

        // Adjust pickup time to match merchant working hour
        let todayPickupTime = moment(this.state.pickupTime)
        let today = moment()
        todayPickupTime.set({
            year: today.get('year'),
            month: today.get('month'),
            date: today.get('date'),
        })
        let businessOpenTime = []
        let businessCloseTime = []
        let isAsap = this.state.isAsap
        if (workingHour && Array.isArray(workingHour) && workingHour.length > 0) {
            let workingHours = workingHour

            let timeSlotFound = false
            let timeSlotEndTime = null
            //      |-------------|        |--------------|     |--------|
            //  A          B          C           D          E       F         G
            // We have many possible scenario
            // A, C, E  - Set to nearest time slot's start time
            // B, D, F  - We are good, set to ASAP
            // G        - Oops, business closed
            let lastIndex = workingHours.length - 1
            workingHours.map( (workingHour, i) => {
                let isThisLastTimeSlot = i == lastIndex
                if (timeSlotFound) {
                    return
                }
                businessOpenTime[i] = moment(workingHour.start_time, "hh:mm:ss")
                businessCloseTime[i] = moment(workingHour.end_time, "hh:mm:ss")

                businessOpenTime[i].set({
                    year: this.state.pickupTime.get('year'),
                    month: this.state.pickupTime.get('month'),
                    date: this.state.pickupTime.get('date'),
                })
                businessCloseTime[i].set({
                    year: this.state.pickupTime.get('year'),
                    month: this.state.pickupTime.get('month'),
                    date: this.state.pickupTime.get('date'),
                })


                // Special case for B, D, F where allow ASAP and also current time (not adjusted with buffer) is within business hours, set to ASAP
                if (this.isAllowAsap() && this.checkTimeWithinWorkingHour(moment(), BUSINESS_OPEN_OFFSET, WorkingHourCheckingType.START_TIME) && now.isBetween(businessOpenTime[i], businessCloseTime[i], null, "[]")) {
                    isAsap = true

                    // This special case of ASAP, we set to 5 minute from now
                    adjustedPickupTime = now.add(5, 'minute')

                    // Skip further time slot checking
                    timeSlotFound = true
                    timeSlotEndTime = businessCloseTime[i]
                }

                // By default, we try to set it to ASAP if possible
                // Case B, D, F
                else if (this.checkTimeWithinWorkingHour(moment(), BUSINESS_OPEN_OFFSET, WorkingHourCheckingType.START_TIME) && this.state.pickupTime.isBetween(businessOpenTime[i], businessCloseTime[i], null, "[]")) {
                    if (this.isAllowAsap()) {
                        isAsap = true
                    }
                    // Skip further time slot checking
                    timeSlotFound = true
                    timeSlotEndTime = businessCloseTime[i]
                }
                else {
                    // Business not yet open, set PickupTime to business open time
                    if (this.state.pickupTime.isSameOrBefore(businessOpenTime[i], 'minute')) {
                        // Skip further time slot checking
                        // A, C or E case
                        timeSlotFound = true
                        timeSlotEndTime = businessCloseTime[i]

                        // Set to start time of time slot
                        adjustedPickupTime.set({
                            hour: businessOpenTime[i].get('hour'),
                            minute: businessOpenTime[i].get('minute'),
                        })
                    }

                    // Case G
                    // Will be handled by isBusinessClosed()
                    adjustedPickupTime = this.roundToNearest15Minute(adjustedPickupTime)
                }
            })

            if (timeSlotFound) {
                adjustedPickupTime = this.roundToNearest15Minute(adjustedPickupTime, timeSlotEndTime)
            }

            this.setState({
                pickupTime: adjustedPickupTime,
                isAsap: isAsap,
            }, this.handlePeakHour)

        } else {
            businessOpenTime = moment(workingHour.start_time, "hh:mm:ss")
            businessCloseTime = moment(workingHour.end_time, "hh:mm:ss")
            businessOpenTime.set({
                year: this.state.pickupTime.get('year'),
                month: this.state.pickupTime.get('month'),
                date: this.state.pickupTime.get('date'),
            })
            businessCloseTime.set({
                year: this.state.pickupTime.get('year'),
                month: this.state.pickupTime.get('month'),
                date: this.state.pickupTime.get('date'),
            })

            // By default, we try to set it to ASAP if possible
            //         |-----------|
            //   A           B           C
            // A    - Business not open
            if (moment().isBetween(businessOpenTime, businessCloseTime, null, [])) {
                // Case B
                isAsap = true
            }
            else {
                // Case A
                // Business not yet open, set PickupTime to business open time
                if (this.state.pickupTime.isBefore(businessOpenTime, 'minute')) {
                    adjustedPickupTime.set({
                        hour: businessOpenTime.get('hour'),
                        minute: businessOpenTime.get('minute'),
                    })
                    adjustedPickupTime = this.roundToNearest15Minute(adjustedPickupTime)
                }

                // Case C
                // Will be handled by isBusinessClosed()
            }

            this.setState({
                pickupTime: adjustedPickupTime,
                isAsap: isAsap,
            }, this.handlePeakHour)
        }
    }

    merchantSettingLoaded = () => {
        const merchantSetting = this.props.app.state.merchantSettings
        const merchantSettingLoaded = merchantSetting && Array.isArray(merchantSetting) && merchantSetting.length
        return merchantSettingLoaded
    }
    handleDPickupDisableRemark = () => {
        this.setState({
            disableRemark: this.getMerchantSettingValue('pickup_disable_remark', false)
        })
    }
    fireCheckPaymentApi = () => {
        let { table_session: tableSession } = this.props.app.state
        // Just fire the API, if has payment, Firebase update will handle the UI and logic flow
        $.ajax({
            url     : `/table_sessions/${tableSession.id}/check_kiple_status?t=${moment().format("YYYY-MM-DD HH:mm:ss")}`
        })
        $.ajax({
            url     : `/table_sessions/${tableSession.id}/check_ipay_status?t=${moment().format("YYYY-MM-DD HH:mm:ss")}`
        })
    }
    // Check if we have payment transactions, so that we can display manual check payment button
    checkHasPayment = () => {
        let { table_session: tableSession } = this.props.app.state
        $.ajax({
            url     : `/table_sessions/${tableSession.id}/payment/has_payment?t=${moment().format("YYYY-MM-DD HH:mm:ss")}`,
            success : (res) => {
                this.setState({
                    hasPendingPayment: res.has_transaction,
                    lastCheckPayment: res.last_check_payment,
                })
            }
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if ( this.state.counterRedirect < 1 && !this.isShowWaitingForPaymentHint() && (!this.props.app.state.orders || this.props.app.state.orders.length < 1) ) {
            this.setState({counterRedirect : 1})
        }
        this.initPickupOrderMode()
        let { table_session } = this.props.app.state
        if (customerId && !permissionRequested && this.props.app.state.current_session && this.props.app.state.current_session.is_pickup_confirmed) {
            permissionRequested = true
            this.requestNotificationPermission()
        }

        if (this.props.app.state.merchant && !this._isWorkingHourLoaded) {
            this._isWorkingHourLoaded = true
            this.adjustPickupTimeForWorkingHour()
        }
        if (prevState.isPeakHour != this.state.isPeakHour) {
            this.calculateDeliveryCost(this.state.deliveryDetail)
        }

        // When loaded page will get promo codes data


        // Merchant setting may will affect delivery price and peak hours
        ReactHelper.handleComponentDidUpdate(this, ['merchantSettings'], () => {
            this.calculateDeliveryCost(this.state.deliveryDetail)
            this.handlePeakHour()
            this.handleDPickupDisableRemark()
        })

        ReactHelper.handleComponentDidUpdate(this, ['menuItems', 'orders'], () => {
            this.calculateOutOfStockOrder()
        })


        if (table_session) {
            // this.isShowWaitingForPaymentHint() = Request user to make payment
            // this.checkedPayment = We only have to check this once per page load
            // this.state.isConfirmAndPay = Skip this check if user click "Confirm and Pay"
            if (this.isShowWaitingForPaymentHint() && !this.checkedPayment && !this.state.isConfirmAndPay) {
                this.checkedPayment = true
                this.fireCheckPaymentApi()
            }

            if (!this.checkedHasPayment) {
                this.checkedHasPayment = true
                this.checkHasPayment()
            }

            if (this.state.isRedirectToPaymentPage && table_session.is_pickup_confirmed) {
                this.props.app.state.merchant.is_payment_gateway_enabled && this.payNoPrompt()
            }
            else if (table_session.is_pickup_confirmed && table_session.delivery_detail_id && !this.state.deliveryDetailLoaded) {
                // Only have to set listener once
                this.setState({ deliveryDetailLoaded: true })
                DeliveryDetailRepository.getInstance().loadOne(table_session.delivery_detail_id, (deliveryDetail) => {
                    this.setState({ deliveryDetail })
                }, this.deliveryDetailRepositoryCallbackKey, this)
            }
            else if (!table_session.is_pickup_confirmed && this.isDelivery() && customerId &&
                !this.props.app.isMerchantHasFeature('is_allow_merchant_use_own_delivery_team') &&
                !this.props.app.isMerchantHasFeature('is_admin_manual_perform_delivery_booking')
            ) {
                // We use the location selected by user that yet to be saved to server

                let { lat, lng } = this.state.deliveryDetail
                let address = buildFullAddress(this.state.deliveryDetail)

                // this one to recalculate delivery fee when delivery coordinate or address changes,
                ReactHelper.handleComponentDidUpdate(this, [{ lat: lat, lng: lng, address: address, pickupTime: this.state.pickupTime, orders: this.props.app.state.orders }], () => {
                    if (this.calculateDeliveryPriceRequest) {
                        this.calculateDeliveryPriceRequest.abort()
                    }
                    this.setState({
                        isCalculatingDeliveryCharge: true,
                    })
                    this.calculateDeliveryPriceRequest = $.ajax({
                        url: `/delivery/calculate_delivery_price`,
                        data: {
                            table_session_id: table_session.id,
                            delivery_detail: this.state.deliveryDetail.toSnakeJson(),
                            pickup_time: this.state.pickupTime.format("YYYY-MM-DD HH:mm")  ,//formatTime(this.state.pickupTime),
                        },
                        success: (res) => {
                            if (res.payment_amount) {
                                // let a = this.props.app.getMerchantSettingValue('delivery_processing_fee')
                                // let processingFee = parseFloat(a == null || a == '' ? DEFAULT_DELIVERY_PROCESSING_FEE : a)
                                let processingFee = DEFAULT_DELIVERY_PROCESSING_FEE   // Already included in API

                                let b = this.props.app.getMerchantSettingValue('delivery_cost_merchant_cover')
                                let merchantCoverFee = parseFloat(b == null || b == '' ? DEFAULT_DELIVERY_COST_MERCHANT_COVER : b)

                                // Add processingFee for 3rd party courier service
                                this.state.deliveryDetail.baseCharge = res.payment_amount
                                this.state.deliveryDetail.deliveryCharge = res.payment_amount + processingFee - merchantCoverFee
                                this.state.deliveryDetail.processingFee = processingFee
                                this.calculateDeliveryCost(this.state.deliveryDetail)
                                this.setState({
                                    isCalculatingDeliveryCharge: false,
                                })
                            }
                        }
                    })
                })
            }
        }
    }
    calculateOutOfStockOrder = () => {
        this.setState({
            outOfStockItems: this.inventoryHelper.getOutOfStockInfo(this.getDraftOrders())
        })
    }
    loadFirebase = () => {
        let me = this
        let firebase_uid = this.props.app.state.customer.firebase_uid || customerId
        firebase_uid && Axios.get(`/customer/get?firebase_uid=${this.props.app.state.customer.firebase_uid}`)
            .then((res) => {
                res && $('#sign-in-div').css('display', 'none')
                res && me.setState({
                    contact: {
                        name: res.data.name || "",
                        phone_number: res.data.phone_number || "",
                        email: res.data.email || "",
                        firebase_uid: res.data.firebase_uid
                    },
                    isFirebaseSignedIn: true
                })
            }).catch((error) => {
                console.log(error)
                this.startFirebase()
            }) || this.startFirebase()
    }

    startFirebase = () => {
        return
    }

    // Make sure we un-register Firebase observers when the component unmounts.
    componentWillUnmount() {
        this.unregisterAuthObserver()
        DeliveryDetailRepository.getInstance().removeCallback(null, this)
        AppSettingRepository.getInstance().removeCallback(null, this)
    }
    getSideDishes = (order) => {
        let sideDishSelection = []
        if (order.side_dish_data && order.side_dish_data.selections && Array.isArray(order.side_dish_data.selections)) {
            sideDishSelection = order.side_dish_data.selections
        }
        return sideDishSelection.map((sd, index) => {
            return <div key={index}>
                &bull; {sd.variation.name}
                {sd.quantity > 1 && ` x ${sd.quantity}`}
            </div>
        })
    }

    getOrderDescription = (order) => {
        let me = this
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == order.menu_item_id)

        return (
            (order.variation == null && order.remark == null && menuItem.take_away_charge < 0) ? this.getSideDishes(order) :
                <div className={'clearfix'} style={{ marginBottom: "5px" }}>
                    <div>
                        <div className={'pull-left'}>
                            <div className={'btn-group mr-2'} role="group" aria-label="Second group" style={{ display: "inline-block" }}>
                                <SelectedSideDishListing app={this.props.app} order={order} />
                                <SelectedVariationListing app={this.props.app} order={order} />
                                <span style={{ display: order.remark ? "block" : "none" }}>{"* " + order.remark}</span>

                                {menuItem.take_away_charge < 0 || !order.take_away ? null :
                                    <span><span>&#10033;</span>{lang.take_away}</span>
                                }
                                {/* <span style={{ textAlign: "right", opacity: "0.5", fontSize: "12px" }}>{"Last updated on " + order.updated_at}</span> */}
                            </div>
                        </div>
                    </div>
                </div>
        )
    }

    showConfirmOrderListing = () => {
        let me = this
        let index = 0

        if (!this.props.app.state.orders || !this.props.app.state.menuItems) {
            return;
        }

        let confirmOrder = this.props.app.state.orders.filter((order) => order.order_status == "accepted" || order.order_status == 'waiting_payment')
        let li = confirmOrder.map((order) => {
            // order.item_name = me.getMenuItemName(order.menu_item_id);
            let listClass = "confirm-order-" + order.id;
            index++;
            return (
                <div className={listClass} key={listClass}>
                    <li className={'list-group-item clearfix'} data-index={index} style={{ verticalAlign: "middle" }} key={order.id} data-id={order.id}>
                        <OrderHeader order={order} currencyName={this.props.currencyName}/>
                        {this.getOrderDescription(order)}
                    </li>
                </div>
            )
        })
        this.promoCodeAsItemListing(li)
        this.extraChargeItemListing(li, {noRightButtons: true})
        return li
    }

    promoCodeAsItemListing = (items) => {
        if (this.props.app.state.current_session.promo_code_data && this.billCalculator.getBillDetail().promo_code_discount) {
            let promoCodeData = this.props.app.state.current_session.promo_code_data
            let discountData = this.props.app.state.current_session.promo_code_data.data.find(d => d.type == PromoCodeType.DISCOUNT_ABSOLUTE || d.type == PromoCodeType.DISCOUNT_PERCENT || d.type == PromoCodeType.FREE_ITEM)
            if (discountData) {
                let index = items.length
                items.push(<li className={`list-group-item clearfix text-danger`} data-index={index} style={{ verticalAlign: "middle" }} key={index} data-id={""}>
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                        {"1x " + (promoCodeData.description || lang.promo_code_discount)}
                        <ItemPrice price={this.billCalculator.getBillDetail().promo_code_discount * -1} currencyName={this.props.currencyName}/>
                    </div>
                </li>)
            }
        }
    }

    getDraftOrders = () => {
        return (this.props.app.state.orders || []).filter((order) => (order.order_status == "draft" || order.order_status == "waiting_payment"))
    }

    showDraftOrderListing = () => {
        let me = this
        let index = 0

        if (!this.props.app.state.orders) {
            return;
        }

        let draftOrder = [...this.getDraftOrders()]
        if (draftOrder.length == 0) {
            return <div></div>
        }

        // Store the index of first item of each set
        let setNumberMapping = {}
        if (this.props.app.isOrderSetBySet()) {
            draftOrder.sort((a,b) => a.set_number - b.set_number)

            // Get orderId of first item of each set
            let lastSetNumber = null
            let displaySetNumber = 1
            for (let i = 0; i < draftOrder.length; i++) {
                let orderItem = draftOrder[i]
                if (lastSetNumber != orderItem.set_number) {
                    setNumberMapping[orderItem.set_number] = {
                        orderId: orderItem.id,
                        displaySetNumber: displaySetNumber++,
                    }

                    // Update comparison result for next loop
                    lastSetNumber = orderItem.set_number
                }
            }
        }

        // Economy rice order style we can group the orders into "set"
        // Add a header for first item of each set
        const setNumberHeader = (order) => {
            let setNumberData = setNumberMapping[order.set_number]
            if (setNumberData && setNumberData.orderId == order.id) {
                return <span style={{position: "absolute", top: "-25px", fontWeight: "bold", fontSize: "120%"}}><u>Set {setNumberData.displaySetNumber}</u></span>
            }
            return null
        }
        let li = draftOrder.map((order) => {
            const isFirstItemInSet = setNumberMapping[order.set_number] && setNumberMapping[order.set_number].orderId == order.id
            // order.item_name = me.getMenuItemName(order.menu_item_id)
            let listClass = "draft-order-" + order.id
            if (isFirstItemInSet) {
                listClass += " mt-5"
            }
            let outOfStockInfo = this.state.outOfStockItems.find(o => o.id === order.id)
            index++;
            return (
                <div style={{ position: "relative" }} className={listClass} key={listClass}>
                    { setNumberHeader(order, index) }
                    <li className={' list-group-item clearfix'} data-index={index} style={{ verticalAlign: "middle", paddingRight: "0px" }} key={order.id} data-id={order.id}>
                        <div style={{display:"flex", flexDirection: "row"}}>
                            <div style={{flex: "1 0 50px"}}>
                                <OrderHeader order={order} currencyName={this.props.currencyName} />
                                {this.getOrderDescription(order)}
                                <div>
                                    <OutOfStockHint outOfStockInfo={outOfStockInfo} order={order} />
                                </div>
                            </div>
                            <div className="ml-2" style={{textAlign: "right"}}>
                                {
                                    this.props.app.state.table && this.props.app.state.table.table_type_bitwise != 1 &&
                                    <div style={{display:"flex", flexDirection: "column", height: "100%"}}>
                                        <button className="" style={{
                                            border: "none",
                                            backgroundColor: "transparent",
                                            width: "25px",
                                        }} data-id={order.id} onClick={this.cancelItemOrder}>
                                            <i className="fas fa-times delete-icon"></i>
                                        </button>
                                        <div style={{ flex: "1 1 10px" }}></div>
                                        <button className="far fa-edit edit-icon" style={{
                                            border: "none",
                                            backgroundColor: "transparent",
                                            width: "25px",
                                        }} onClick={() => { this.showEditDialog(order) }}/>
                                    </div>
                                }
                            </div>
                        </div>
                    </li>
                </div>
            )
        })
        this.promoCodeAsItemListing(li)
        this.extraChargeItemListing(li)
        this.askUserNeedUtensilAsItemListing(li)
        return li
    }

    askUserNeedUtensilAsItemListing = (items) => {
        const askUserNeedUtensil = this.state.askUserNeedUtensil
        if (!askUserNeedUtensil) {
            return
        }
        const langs = this.props.app.getMerchantSettingValue(MerchantSettingKey.ASK_USER_NEED_UTENSILS_TEXT + ":user")
        if (langs) {
            try {
                let langParsed = JSON.parse(langs)
                const text = langParsed && langParsed[window.selectedLang]
                const listClass = ''
                items.push(<div style={{ position: "relative", padding: "5px" }} className={listClass} key={listClass}>
                    <label>
                        <input type="checkbox" onClick={this.isNeedUtensilChange} checked={this.state.isNeedUtensil} /> {text}
                    </label>
                </div>)
            } catch {}
        }
    }

    isNeedUtensilChange = () => {
        this.setState({
            isNeedUtensil: !this.state.isNeedUtensil
        })
    }

    extraChargeItemListing = (items, options = {}) => {
        let extraChargeData =  this.props.app.state.current_session?.extra_data?.extra_charge
        if (extraChargeData && extraChargeData.value) {
            const extraCharge       = CalculationHelper.round2dp(parseFloat(extraChargeData.value))
            const extraChargeReason = extraChargeData.reason || lang.extra_charge
            const customOrderItem = {
                quantity: 1,
                desc    : extraChargeReason,
                price   : extraCharge,
            }
            let index = items.length
            let listClass = "draft-order-extra-charge"

            if (options.noRightButtons) {
                items.push(<li className={`list-group-item clearfix text-danger`} style={{ verticalAlign: "middle" }} key={index}>
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                        {"1x " + (extraChargeReason)}
                        <ItemPrice price={extraCharge} currencyName={this.props.currencyName}/>
                    </div>
                </li>)
            }
            else {
                items.push(<div style={{ position: "relative" }} className={listClass} key={listClass}>
                    <li className={`list-group-item clearfix text-danger`} style={{ verticalAlign: "middle", paddingRight: "0px" }}>
                        <div style={{display:"flex", flexDirection: "row"}}>
                            <div style={{flex: "1 0 200px"}}>
                                <OrderHeader customOrderItem={customOrderItem} currencyName={this.props.currencyName} />
                            </div>
                            <div className="ml-2" style={{textAlign: "right"}}>
                                <div style={{width: "25px"}}></div>
                            </div>
                        </div>
                    </li>
                </div>)
            }
        }
    }
    fireCancelOrderApi = (order, callback) => {
        $.ajax({
            url: "/orders/" + order.id,
            type: "patch",
            data: {
                update_order_status_only: 1,
                order_status: "cancelled",
            },
            success: function (response) {
                callback && callback()
            }
        })
    }
    cancelItemOrder(e) {
        e.stopPropagation()

        let orderItemId = e.currentTarget.dataset.id * 1
        let me = this;
        const onYes = () => {
            let id = orderItemId
            let order = this.props.app.state.orders.find((item) => item.id == id)

            let listClass = ".draft-order-" + order.id;
            $(listClass).slideUp('slow')

            let draftOrder = this.props.app.state.orders.filter((order) => order.order_status == "draft")
            let current = draftOrder.length - 1
            $('#tab-draft').text("Draft (" + current.toString() + ")")
            if (current == 0) {
                $('#place-order-button').hide();
            }

            this.fireCancelOrderApi(order)
            onClose()
        }
        const onClose = () => {
            this.setState({
                confirmModal: null,
            })
        }
        this.setState({
            confirmModal: <ConfirmModal
                isYesDestructive={true}
                ref={this.confirmModalRef}
                pickup={this.props.app.state.table.pickup}
                message={lang.confirm_remove_from_cart}
                buttonLayout="vertical"
                onClose={onClose}
                onYes={onYes}
                onNo={onClose}
            />
        })
    }
    onSubmit = (values, actions) => {
        if (!this.state.pickupTime) {
            return
        }

        if (!this.isValidPickupTime()) {
            let errorMessage = this.isDelivery() ?
                "Invalid delivery time, please change your delivery time" :
                "Invalid pickup time, please change your pickup time"
            actions.setSubmitting(false)
            this.setState({errorMessage})
            return
        }

        let message = lang.asking_place_order.replace("<br>", "\n");
        this.setState({
            confirmModal: <ConfirmModal
                ref={this.confirmModalRef}
                pickup={this.props.app.state.table.pickup}
                message={message}
                buttonLayout="vertical"
                onClose={() => {
                    actions.setSubmitting(false)
                    this.setState({
                        confirmModal: null
                    })
                }}
                onYes={() => {
                    this.submit(values, actions, this.confirmModalRef.current)
                }}
                onNo={() => {
                    actions.setSubmitting(false)
                    this.setState({
                        confirmModal: null
                    })
                }}
            />
        })
    }

    checkDineInTable = () => {
        console.log(this.state.dineInTableId)
        if (this.isDineInWithPayment() && !this.state.dineInTableId) {
            return false
        }
        return true
    }

    submit(values, actions, confirmDialog) {
        let isDelivery = OrderHandler.getTableSessionType() == TableSessionType.DELIVERY
        let pickupTime = this.state.pickupTime
        if (this.state.isAsap) {
            pickupTime = moment()
        }
        const finalPickupTime = pickupTime.format('YYYY-MM-DD hh:mm a')

        if (!this.checkDineInTable()) {
            confirmDialog.close()

            this.setState({
                errorMessage: lang.please_select_table,
                errorMsgOnClose: () => {
                    this.setState({
                        errorMsgOnClose: null,
                    }, () => {
                        scrollToTargetAdjusted('select-dine-in-table')
                        this.setState({
                            highlightSelectTableCard: true,
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    highlightSelectTableCard: false,
                                })
                            }, 1500)
                        })
                    })
                }
            }, () => {

            })
            return
        }


        let checkPickupTime = finalPickupTime
        let pickupTimeDef = finalPickupTime
        if (this.isDelivery()) {
            this.state.deliveryDetail.deliveryDatetime = checkPickupTime
            this.state.defpickupTime = checkPickupTime
        }

        let deliveryDetail = isDelivery && OrderHandler.getDeliveryDetail().toSnakeJson()
        if (deliveryDetail) {
            // Passing ID will cause duplicate ID update
            // TODO: Handle this in server side
            delete(deliveryDetail.id)
        }

        let isAsap = this.state.isAsap
        if (this.isDineInWithPayment()) {
            isAsap = true
        }
        let data = {
            merchant_id: this.props.app.state.table.merchant_id,
            table_id: this.props.app.state.table.id,
            order_status: "waiting_payment",
            name: values.name || '',
            phone_number: values.phone_number || '',
            email: values.email || '',
            firebase_uid: values.firebase_uid || '',
            is_asap: isAsap ? 1 : 0,
            pickup_time: pickupTimeDef,
            remark: values.remark,
            is_drive_through: values.is_drive_through ? 1 : 0,
            car_plate_number: values.car_plate_number,

            delivery_detail: deliveryDetail,

            merchant_cover_cost_reason: this.state.merchant_cover_cost_reason,

            dine_in_table_id: this.state.dineInTableId,
            is_need_utensil: this.state.isNeedUtensil,
        }

        confirmDialog.isLoading(true)
        actions.setSubmitting(true)
        this.setState({
            isConfirmAndPay: true,
        })
        Axios.post(`/orders/update_order_status`, data).then((res) => {
            actions.setSubmitting(false)
            confirmDialog.close()

            // Success save delivery data (if any) to DB, clear from localStorage
            // so that next new order shall let user choose new location
            OrderHandler.removeFromLocalStorage()

            this.setState({
                isRedirectToPaymentPage: true,
            })
        })
        .catch((error) => {
            actions.setSubmitting(false)

            if (error.response.data.errors) {
                // Server return error for each field
                actions.setErrors(errors)
            }
            confirmDialog.close()

            let message = lang.unable_to_place_order_order_manually
            if (error.response.status == 422 && error.response.data.message == message) { }
            else {
                message = (error.response.data && error.response.data.message) || error.message
            }
            this.setState({
                errorMessage: message
            })
        }).finally(() => {

        })
    }

    payNoPrompt = () => {
        let tableQR = this.props.match.params.tableQR
        this.props.history.push(`/payment/${tableQR}`)
    }

    pay() {
        let me = this
        let tableQR = this.props.match.params.tableQR
        this.setState({
            paymentMethodModal: <ConfirmModal
                ref={this.paymentMethodModalRef}
                pickup={this.props.app.state.table.pickup}
                message={lang.choose_payment_method}
                buttonLayout="vertical"
                onClose={() => {
                    this.setState({
                        paymentMethodModal: null
                    })
                }}
                onYes={() => {
                    me.props.history.push(`/payment/${tableQR}`)
                }}
                yesText={lang.payment_method_online}
                onNo={() => {
                    me.setState({
                        paymentMethodModal: null
                    })
                }}
                noText={lang.payment_method_counter}
            />
        })
    }

    onCancelOrder = () => {
        let message = (lang.confirm_cancel_order || "Sure to cancel this order?").replace("<br>", "\n");
        this.setState({
            confirmNewModal: <ConfirmModal
                isYesDestructive={true}
                yesText={lang.cancel_order || "Cancel Order"}
                ref={this.confirmNewModalRef}
                pickup={this.props.app.state.table.pickup}
                message={message}
                table_session_id={table_session_id}
                cancelOrderProp={true}
                onClose={() => {
                    this.setState({
                        confirmNewModal: null
                    })
                }}
                onYes={() => {
                    this.cancelOrder(this.confirmNewModalRef.current)
                }}
                onNo={() => {
                    this.setState({
                        confirmNewModal: null
                    })
                }}
            />
        })
    }

    cancelOrder = (confirmNewDialog) => {
        confirmNewDialog.isLoading(true)
        Axios.post(`/customer/table_sessions/${table_session_id}/cancel_order`)
            .then((res) => {
                console.log(res)
                pageReload.goTo(`/${this.props.match.params.tableQR}`)
            }).catch((error) => {
                alert(error.message)
            }).finally(() => {
                confirmNewDialog.close()
            })
    }

    onRestartOrder() {
        let message = lang.confirm_new_order.replace("<br>", "\n");
        this.setState({
            confirmNewModal: <ConfirmModal
                ref={this.confirmNewModalRef}
                pickup={this.props.app.state.table.pickup}
                message={message}
                buttonLayout="vertical"
                onClose={() => {
                    this.setState({
                        confirmNewModal: null
                    })
                }}
                onYes={() => {
                    this.restartOrder(this.confirmNewModalRef.current)
                }}
                onNo={() => {
                    this.setState({
                        confirmNewModal: null
                    })
                }}
            />
        })
    }

    restartOrder = (confirmNewDialog) => {
        confirmNewDialog.isLoading(true)
        Axios.post(`/pickup/new_order`, {
            table_session_id: this.props.app.state.table_session.id
        }).then((res) => {
            console.log(res)
            pageReload.goTo(`/${this.props.match.params.tableQR}`)
        }).catch((error) => {
            alert(error.message)
        }).finally(() => {
            confirmNewDialog.close()
        })
    }

    isDelivery = () => {
        return OrderHandler.getTableSessionType() == TableSessionType.DELIVERY
    }

    onChangeAddressClicked = () => {
        Navigator.goToSelectDeliveryLocation({
            back: `/pickup/${table_qr}`,
            hideFooter: true,
            onConfirm: `/pickup/${table_qr}`,
        })
    }

    getPickupOrderModes = () => {
        return PickupOrderMode.getPickupOrderModes()
    }

    setPickupOrderMode = (pickupOrderMode) => {
        if (window.table_session_id) {
            this.setState({
                isUpdatingPickupOrderMode: true
            }, () => {
                // If no extra charge, edit/reset/unset value at DB to null,
                // Pass empty array as null key-value with be omitted by $.ajax
                let extraCharge = -1
                if (pickupOrderMode) {
                    const extraChargeValue = PickupOrderMode.getPickupOrderModesExtraCharge(pickupOrderMode)
                    if (extraChargeValue) {
                        extraCharge = {
                            value   : extraChargeValue,
                            reason  : pickupOrderMode,
                        }
                    }
                }
                $.ajax({
                    url     : `/table_sessions/${window.table_session_id}/update_pickup_order_mode`,
                    type    : 'post',
                    data    : {
                        pickup_order_mode: pickupOrderMode,
                        extra_data: {
                            extra_charge: extraCharge
                        },
                    },
                    success : () => {
                        // Wait for Firebase UI update
                    }
                })
                .always(() => {
                    this.setState({
                        isUpdatingPickupOrderMode: false
                    })
                })
            })
        }
    }

    onChangePickupOrderModeClicked = () => {
        const closeModal = () => this.setState({ changePickupOrderModeModal: null })
        const currencyName = this.props.app.state.currencyName || ""
        const choices = this.getPickupOrderModes().map((orderMode) => {
            const extraCharge = PickupOrderMode.getPickupOrderModesExtraCharge(orderMode)
            const extraChargeText = extraCharge ? `(${lang.extra_charge} ${currencyName}${extraCharge.toFixed(2)})` : ""
            return {
                label: `${orderMode} ${extraChargeText}`,
                value: orderMode,
            }
        })
        let onChoiceSelected = (choice) => {
            closeModal()
            this.setPickupOrderMode(choice.value)
        }
        let onNo = () => {
            closeModal()
        }
        this.setState({
            changePickupOrderModeModal: <SelectOneFromManyModal
                message={"Choose your order mode"}
                buttonLayout="vertical"
                choices={choices}
                onClose={closeModal}
                onChoiceSelected={onChoiceSelected}
                onNo={onNo}
            />
        })
    }
    onChangeOrderModeClicked = () => {
        // We are Pickup mode
        // 1. Change to delivery mode
        // 2. Continue with Pickup
        let yesText = lang.delivery
        let noText = lang.pickup

        const closeModal = () => this.setState({ changeOrderModeModal: null })

        const isDelivery = OrderHandler.getTableSessionType() == TableSessionType.DELIVERY

        let onYes = () => {
            closeModal()
            if (isDelivery) {
                return
            }
            this.onChangeAddressClicked()
        }

        let onNo = () => {
            if (isDelivery) {
                OrderHandler.setTableSessionType(TableSessionType.PICKUP)
            }
            closeModal()
        }

        this.setState({
            changeOrderModeModal: <ConfirmModal
                message={"Choose your order mode"}
                buttonLayout="vertical"
                onClose={closeModal}
                onYes={onYes}
                yesText={yesText}
                onNo={onNo}
                noText={noText}
            />
        })
    }

    renderOrderListing = () => {
        return <div style={{ padding: '10px 10px 10px 10px', marginBottom: "10px", backgroundColor: "white" }}>
            <h3>{lang.your_orders}</h3>
            <ul className="list-group">{this.showConfirmOrderListing()}</ul>
        </div>
    }
    isDoNotAllowChooseDeliveryTime = () => {
        return this.isDelivery() && !!parseInt(this.props.app.getMerchantSettingValue('is_do_not_allow_choose_delivery_time'))
    }
    getTodayWorkingHour = () => {
        const workingHour = (this.props.app.state.merchant.working_hours || []).find( workingHour => workingHour.day == moment().format('day') )
        return workingHour || WorkingHourHandler.getInstance().getDefaultWorkingHours()
    }

    /**
     * Return an array of business working hours
     * @param {Object} momentDate
     * @returns Array
     */
    getWorkingHour = (momentDate) => {
        let publicHoliday = this.props.app.state.publicHoliday ? this.props.app.state.publicHoliday.find( holiday =>  moment(holiday.ph_date).isSame( momentDate, 'day' ) ) : null
        let workingHourType = this.isDelivery() ? WorkingHourType.DELIVERY : WorkingHourType.PICKUP

        if (this.isDineInWithPayment()) {
            workingHourType = WorkingHourType.DINE_IN
        }

        let workingHours = []
        // Use public holiday working hour
        if (publicHoliday) {
            workingHours = (this.props.app.state.merchant.working_hours || []).filter( workingHour => {
                return workingHour.day == 'PH'
            })
        }
        else {
            // Use normal working day working hours
            // 1. Try use Delivery/Pickup specific working hour
            workingHours = (this.props.app.state.merchant.working_hours || []).filter( workingHour => {
                return workingHour.day == momentDate.format('ddd') && workingHour.type == workingHourType
            })

            // 2. Fallback to use Dine In working hours
            if (workingHours.length == 0) {
                workingHours = (this.props.app.state.merchant.working_hours || []).filter( workingHour => {
                    return workingHour.day == momentDate.format('ddd') && workingHour.type == WorkingHourType.DINE_IN
                })
            }
        }
        if (workingHours.length === 0) {
            // No working hour set for this day, use default working, return as single element array
            workingHours = [WorkingHourHandler.getInstance().getDefaultWorkingHours()]
        }
        return workingHours
    }
    getBusinessClosedDays = () => {
        let closedDays = []
        let workingHours = this.props.app.state.merchant.working_hours || []
        workingHours.forEach(workingHour => {
            let businessOpen = moment(workingHour.start_time, "hh:mm:ss")
            let businessClose = moment(workingHour.end_time, "hh:mm:ss")
            if (businessClose.diff(businessOpen, 'minute') <= 1) {
                closedDays.push(workingHour.day)
            }
        })
        return closedDays
    }
    /**
     * Get the business hour of given day. No day is given, then
     * will return business hour of day of selected pickup time
     * @param {Moment} momentDate
     */
    getBusinessOpenAndCloseTime = (momentDate) => {
        if (!momentDate) {
            momentDate = this.state.pickupTime
        }
        let workingHour = this.getWorkingHour(momentDate)
        let businessOpen = []
        let businessClose = []
        let maxOrderTime = []
        let start = []
        let end = []
        let minimumOrderTime = []
        let isMenuNotInBusinessHour = []
        const { menuStartTime, menuEndTime } = this.getMerchantMenuTime(momentDate)

        if (Array.isArray(workingHour)) {
            let workingHours = workingHour
            workingHours.map( (workingHour, i) => {
                start[i] = moment(momentDate)
                end[i] = moment(momentDate)
                businessOpen[i] = moment(workingHour.start_time, "hh:mm:ss")
                businessClose[i] = moment(workingHour.end_time, "hh:mm:ss")
                // Init from momentDate to get same date, later we can safely just
                // compare the time part
                start[i].set({
                    hour: businessOpen[i].get("hour"),
                    minute: businessOpen[i].get("minute"),
                })

                // Make sure the first time slot to be chosen already include buffer time
                const nowWithBufferTime = moment().add(this.getBufferTime(), 'minute')
                minimumOrderTime[i] = start[i].isAfter(nowWithBufferTime, 'minute') ? start[i].clone() : moment().add(this.getBufferTime(), 'minute')

                // Init from momentDate to get same date, later we can safely just
                // compare the time part
                end[i].set({
                    hour: businessClose[i].get("hour"),
                    minute: businessClose[i].get("minute"),
                })

                // Adjust available time according to selected menu
                isMenuNotInBusinessHour = this.adjustTimeForMerchantMenu(minimumOrderTime[i], end[i], menuStartTime, menuEndTime)
                maxOrderTime[i] = end[i].clone()

                this.roundToNearest15Minute(minimumOrderTime[i])

                if (!workingHour.type || workingHour.type == WorkingHourType.DINE_IN) {
                    // If using dine in working hour, we make some adjustment so that last order time
                    // is 15 minutes before closing time.
                    this.roundToNearest15Minute(end[i], maxOrderTime[i])

                    // Else, just use the end time of Pickup/Delivery as it is
                }

                if(end[i].diff(start[i], 'minute') <= 1) {
                    start[i].subtract(15, 'minutes')
                }
            })
            return {start, end, minimumOrderTime, maxOrderTime, isMenuNotInBusinessHour}
        }
        else {
            const start = moment(momentDate)
            const end = moment(momentDate)
            businessOpen = moment(workingHour.start_time, "hh:mm:ss")
            businessClose = moment(workingHour.end_time, "hh:mm:ss")
            // Init from momentDate to get same date, later we can safely just
            // compare the time part
            start.set({
                hour: businessOpen.get("hour"),
                minute: businessOpen.get("minute"),
            })

            const minimumOrderTime = start.isAfter(moment(), 'minute') ? start.clone() : moment().add(this.getBufferTime(), 'minute')

            // Init from momentDate to get same date, later we can safely just
            // compare the time part

            end.set({
                hour: businessClose.get("hour"),
                minute: businessClose.get("minute"),
            })

            // Adjust available time according to selected menu
            const { isMenuNotInBusinessHour } = this.adjustTimeForMerchantMenu(minimumOrderTime, end, menuStartTime, menuEndTime)
            const maxOrderTime = end.clone()

            this.roundToNearest15Minute(minimumOrderTime)
            this.roundToNearest15Minute(end, maxOrderTime)

            if(end.diff(start, 'minute') <= 1) {
                start.subtract(15, 'minutes')
            }
            return {start, end, minimumOrderTime, maxOrderTime, isMenuNotInBusinessHour}
        }
    }

    getBusinessClosedReason = () => {
        if (!this.props.app.state.merchant.is_pickup_online && OrderHandler.getTableSessionType() == TableSessionType.PICKUP) {
            return lang.pickup_order_disabled
        }
        else if (!this.props.app.state.merchant.is_pickup_and_delivery_online && OrderHandler.getTableSessionType() == TableSessionType.DELIVERY) {
            return lang.delivery_order_disabled
        }
        else {
            return lang.business_is_closed
        }
    }
    merchantOffDayFilter = (momentDate) => {
        const merchantOffDays = this.getMerchantOffDays()
        if (merchantOffDays) {
            for (const mod of merchantOffDays) {
                let dateToCheck = moment(mod.off_day, "YYYY-MM-DD")
                if (dateToCheck.isSame(momentDate, 'day')) {
                    return false
                }
            }
        }
        return true
    }
    isBusinessClosed = () => {
        let { minimumOrderTime, maxOrderTime, start, end } = this.getBusinessOpenAndCloseTime()

        let businessClosedDays = this.getBusinessClosedDays()
        let x = null
        let y = null

        const disallowPickup = (!this.props.app.state.merchant.is_pickup_online && OrderHandler.getTableSessionType() == TableSessionType.PICKUP)
        const disallowDelivery = (!this.props.app.state.merchant.is_pickup_and_delivery_online && OrderHandler.getTableSessionType() == TableSessionType.DELIVERY)
        if( this.props.app.state.merchant && ( disallowPickup || disallowDelivery ) ) {
            return true
        }

        if (this.isDineInWithPayment()) {
            // For Dine In, it is ASAP order, if merchant turn offline,
            // then cannot order
            if (this.props.app.state.merchant.is_online) {
                return false
            }
            return true
        }
        else {
            // Handle Pickup/Delivery
            // Filter business not opened days
            if (maxOrderTime && Array.isArray(maxOrderTime)) {
                x = maxOrderTime.map( (maxOrderTimes, i) => {
                    if (businessClosedDays.indexOf(moment(maxOrderTimes).format('ddd')) !== -1) {
                        // maxOrderTime is within OFF DAY, ie working hour = 00:00 - 00:01
                        return true
                    }
                    // merchantOffDayFilter return false if is within merchantOffDay
                    if (!this.merchantOffDayFilter(moment(maxOrderTimes))) {
                        return true
                    }
                    return maxOrderTimes.isSameOrBefore(moment(), 'minute') || minimumOrderTime[i].isSameOrAfter(end, 'minute')
                })
                y = (yVal) => yVal === true
                if (x.every(y)) {
                    return true
                }
            }
            else {
                if (businessClosedDays.indexOf(moment(maxOrderTime).format('ddd')) !== -1) {
                    // maxOrderTime is within OFF DAY
                    return true
                }
                return maxOrderTime.isSameOrBefore(moment(), 'minute') || minimumOrderTime.isSameOrAfter(end, 'minute')
            }
        }
    }

    isValidPickupTime = () => {
        if (this.isDoNotAllowChooseDeliveryTime()) {
            return true
        }

        // Assume user is smart enough to not order when
        // he "see" that business is not open. User suppose
        // to order when only in business premise
        if (this.isDineInWithPayment()) {
            return true
        }

        let timeToCheck = this.state.pickupTime
        let checkingType = WorkingHourCheckingType.MINIMUM_ORDER_TIME
        if (this.state.isAsap) {
            // We are doing ASAP order, as long as current time is within working hour
            // as not after "last call time" then we can place order.
            // MINIMUM_ORDER_TIME is only suitable for preOrder, where time to collect shall be
            // MINIMUM_ORDER_TIME = now + buffer time
            timeToCheck = moment()
            checkingType = WorkingHourCheckingType.START_TIME
        }

        if (!this.checkTimeWithinWorkingHour(timeToCheck, 5, checkingType)) {
            return false
        }

        let isAsapWhenNotToday = this.state.isAsap && !this.state.pickupTime.isSame(moment(), 'day')
        if (isAsapWhenNotToday) {
            const timeTillTomorrow = moment().endOf('day').diff(moment(),'minute')
            // const timeTillTomorrow = this.state.pickupTime.diff(moment(),'minute')
            if (timeTillTomorrow >= 0 && timeTillTomorrow < 15) {
                // At end of day, say 23:45pm, so pickupTime will of offset to 00:00 of next day,
                // we should allow to place this ASAP order
            }
            else {
                return false
            }
        }

        // Is Asap when not allowed to Asap order
        if (!this.isAllowAsap() && this.state.isAsap) {
            return false
        }
        return true
    }
    /**
     * If a given time is within working hours, allow some offset value.
     * Eg:
     * Working hour = 8.00am - 11.00am, offset = 5 minute, then
     *
     * Any time within 7.55am - 11.00am will be considered "true"
     *
     */
    checkTimeWithinWorkingHour = (momentTime, offset, checkingType) => {
        const { start, minimumOrderTime, maxOrderTime } = this.getBusinessOpenAndCloseTime(momentTime)
        let minimumOrderTimeSubtracted = []
        let isOutsideWorkingHour = []

        let workingHourPortionToCheck = []

        switch (checkingType) {
            case WorkingHourCheckingType.START_TIME:
                workingHourPortionToCheck = start
                break
            case WorkingHourCheckingType.MINIMUM_ORDER_TIME:
                workingHourPortionToCheck = minimumOrderTime
                break
            default:
                workingHourPortionToCheck = minimumOrderTime
        }
        if (workingHourPortionToCheck && Array.isArray(workingHourPortionToCheck)) {
            workingHourPortionToCheck.map((minOrderTime, i) => {
                minimumOrderTimeSubtracted[i] = minOrderTime.subtract(offset, 'm')
                isOutsideWorkingHour[i] = !this.isBusinessClosed() && (momentTime.isBefore(minimumOrderTimeSubtracted[i], 'minute') || momentTime.isAfter(maxOrderTime[i], 'minute'))
            })
        }
        else {
            minimumOrderTimeSubtracted.push(workingHourPortionToCheck.subtract(5, 'm'))
            isOutsideWorkingHour.push(!this.isBusinessClosed() && (momentTime.isBefore(minimumOrderTimeSubtracted[0], 'minute') || momentTime.isAfter(maxOrderTime, 'minute')))
        }
        if (isOutsideWorkingHour.length > 0) {
            let checker = arr => arr.every(v => v === true);
            if ( checker(isOutsideWorkingHour)) {
                return false
            }
        } else {
            if (isOutsideWorkingHour) {
                return false
            }
        }
        return true
    }
    checkPickupTimeWithinWorkingHour = () => {
        if (this.isDoNotAllowChooseDeliveryTime()) {
            return
        }
        if (!this.isValidPickupTime()) {
            this.setState({isAsap: false})
            setTimeout(this.showTimePicker, 300)
            return
        }
        this.handlePeakHour()
    }
    getMerchantMenu = () => {
        // -1 is all day menu
        if (this.props.app.state.selectedMerchantMenuId > 0) {
            return this.props.app.state.merchantMenus.find(mm => mm.id == this.props.app.state.selectedMerchantMenuId)
        }
        return null
    }
    getMerchantMenuTime = (momentDate) => {
        if (!momentDate) {
            momentDate = this.state.pickupTime
        }

        let menuEndTime, menuStartTime
        let merchantMenu = this.getMerchantMenu()
        if (merchantMenu && merchantMenu.time_start && merchantMenu.time_end) {
            let ref = moment(merchantMenu.time_start, "HH:mm")
            menuStartTime = moment(momentDate) // Get same date part
            menuStartTime.set({
                'hour'  : ref.get('hour'),
                'minute': ref.get('minute'),
                'second': ref.get('second'),
            })

            ref = moment(merchantMenu.time_end, "HH:mm")
            menuEndTime = moment(momentDate) // Get same date part
            menuEndTime.set({
                'hour'  : ref.get('hour'),
                'minute': ref.get('minute'),
                'second': ref.get('second'),
            })
        }
        return { menuStartTime, menuEndTime }
    }
    adjustTimeForMerchantMenu = (businessStart, businessEnd, menuStart, menuEnd) => {
        let isMenuNotInBusinessHour = false
        businessStart = businessStart.clone()
        businessEnd = businessEnd.clone()
        if (businessStart && businessEnd && menuStart && menuEnd) {
            //         BusinessStart                       BusinessEnd
            //              |-------------------------------------|
            //     |-----------------|                |-----------------|
            //   MenuStart-A      MenuEnd-A         MenuStart-B      MenuEnd-B
            //              |--------|                |-----------|
            //            Start     End             Start        End   (This line is final result)
            //
            //                      |-----------------|
            //                  MenuStart-C        MenuEnd-C
            //                      |-----------------|
            //                      Start            End        (This line is final result)
            //

            // Case A
            // Adjust MenuStart to be same as BusinessStart
            if (menuStart.isSameOrBefore(businessStart) && menuEnd.isBetween(businessStart, businessEnd, 'minute', '[]')) {
                // Start = Original BusinessStart (no change)
                // End = menuEnd
                businessEnd.set({
                    'hour'  : menuEnd.get('hour'),
                    'minute': menuEnd.get('minute'),
                    'second': menuEnd.get('second'),
                })
            }

            // Case B
            // Adjust MenuEnd to be same as BusinessEnd
            else if (menuEnd.isSameOrAfter(businessEnd) && menuStart.isBetween(businessStart, businessEnd, 'minute', '[]')) {
                // Start = menuStart
                // End = Original BusinessEnd (no change)
                businessStart.set({
                    'hour'  : menuStart.get('hour'),
                    'minute': menuStart.get('minute'),
                    'second': menuStart.get('second'),
                })
            }

            // Case C
            else if (menuStart.isSameOrAfter(businessStart) && menuEnd.isSameOrBefore(businessEnd)) {
                // Follow menu time
                businessStart.set({
                    'hour'  : menuStart.get('hour'),
                    'minute': menuStart.get('minute'),
                    'second': menuStart.get('second'),
                })
                businessEnd.set({
                    'hour'  : menuEnd.get('hour'),
                    'minute': menuEnd.get('minute'),
                    'second': menuEnd.get('second'),
                })
            }
            else if (menuStart.isSameOrAfter(businessEnd) || menuEnd.isSameOrBefore(businessStart)) {
                // Menu fall outside of business hours
                // 00:00 - 00:01 is "trick" to indicate business not open today
                businessStart.set({
                    'hour'  : 0,
                    'minute': 0,
                    'second': 0,
                })
                businessEnd.set({
                    'hour'  : 0,
                    'minute': 1,
                    'second': 0,
                })
                isMenuNotInBusinessHour = true
            }
        }
        return {
            isMenuNotInBusinessHour
        }
    }
    showTimePicker = () => {
        const { start, end, minimumOrderTime, maxOrderTime } = this.getBusinessOpenAndCloseTime()

        // Adjust available time according to selected menu
        // this.adjustTimeForMerchantMenu(start, end, menuStartTime, menuEndTime)
        const onClose = (isNeedCheckTime) => {
            this.setState({timePickerModal: null}, () => {
                if (isNeedCheckTime) {
                    this.checkPickupTimeWithinWorkingHour()
                }
            })
        }

        let merchantMenuHint = ""
        const merchantMenu = this.getMerchantMenu()
        const { menuStartTime, menuEndTime } = this.getMerchantMenuTime()
        if (merchantMenu && menuStartTime && menuEndTime) {
            merchantMenuHint = lang.menu_available_time_hint
                .replace("%menu_name%", merchantMenu[`name_${window.selectedLang}`] || merchantMenu["name_en"])
                .replace("%time%", `${formatTime(menuStartTime)} - ${formatTime(menuEndTime)}`)
        }

        this.setState({
            timePickerModal: <TimePickerModal
                realStart={start}
                start={minimumOrderTime}
                end={end}
                isBusinessClosed={this.isBusinessClosed()}
                merchantMenuHint={merchantMenuHint}
                businessClosedText={merchantMenuHint ? merchantMenuHint : lang.business_closed}
                onClose={onClose}
                onNo={onClose}
                isAllowAsap={this.isAllowAsap() && this.checkTimeWithinWorkingHour(moment(), 5, WorkingHourCheckingType.START_TIME)}
                isDelivery={this.isDelivery()}
                isPreOrderOnly={this.isPreOrderOnly()}
                onTimeSelected={(time) => {
                    const pickupTime = moment(this.state.pickupTime)
                    pickupTime.set({
                        'hour'  : time.get('hour'),
                        'minute': time.get('minute'),
                        'second': time.get('second'),
                    })
                    let isAsap = false
                    this.setState({pickupTime, isAsap})
                    onClose(true)
                    this.setState({defpickupTime : pickupTime.format("hh:mm a")})
                }}
                onTimeSelected2={(currentTime) => {
                    let isAsap = true
                    const pickupTime = this.getPickupTime()
                    pickupTime.set({
                        'hour'  : currentTime.get('hour'),
                        'minute': currentTime.get('minute'),
                        'second': currentTime.get('second'),
                    })
                    this.setState({ isAsap, pickupTime })
                    onClose(true)
                    this.setState({defpickupTime : pickupTime.format("hh:mm a") + " (ASAP)"})
                }}
            />
        })
    }

    toDateDayString = (moment) => {
        let date = moment.toDate()
        return Formatter.getDateInStandardFormat(date) + " " + Formatter.getDayString(date.getDay())
    }

    nowAvailability = () => {
        let workingHours = this.getWorkingHour(this.state.pickupTime)
        let adjustedPickupTime = []
        let businessOpenTime = []
        let businessCloseTime = []
        let adjustedPickupHour1 = []
        let adjustedPickupMinute1 = []
        let currentTime = moment()
        let defaultDeliveryServiceTime = moment({hour: OP_HOUR, minute: OP_MIN, second: 0, milisecond: 0})
        let businessMinute = []
        let businessHour = []
        let businessMinute1 = []
        let businessHour1 = []
        let diffMin = []
        let diffHour = []
        let diffMin1 = []
        let diffHour1 = []
        let pickupMinute = []
        let pickupHour = []
        let mapContainer = null
        if (workingHours && Array.isArray(workingHours) && workingHours.length > 0) {
            mapContainer = workingHours.map( ( workingHour, i ) => {
                adjustedPickupTime[i] = moment(this.state.pickupTime)
                businessMinute1 = OP_MIN
                businessHour1 = OP_HOUR
                businessOpenTime[i] = moment(workingHour.start_time, "hh:mm:ss")
                businessCloseTime[i] = moment(workingHour.end_time, "hh:mm:ss")
                adjustedPickupHour1[i] = adjustedPickupTime[i].format("HH")
                adjustedPickupMinute1[i] = adjustedPickupTime[i].format("mm")
                diffMin1[i] = adjustedPickupMinute1[i] - businessMinute1
                diffHour1[i] = adjustedPickupHour1[i] - businessHour1
                if(this.isBusinessClosed()){
                    return "--"
                }
                if( (this.isDelivery() && currentTime.isBefore(defaultDeliveryServiceTime) && this.state.defpickupTime == null) || diffHour1[i] == 0 && diffMin1[i] < 15 ) {
                    adjustedPickupTime[i] = this.roundToNearest15Minute(defaultDeliveryServiceTime)
                    pickupMinute[i] = adjustedPickupTime[i].format("mm")
                    pickupHour[i] = adjustedPickupTime[i].format("HH")
                    businessMinute = OP_MIN
                    businessHour = OP_HOUR
                    diffMin[i] = pickupMinute[i] - businessMinute
                    diffHour[i] = pickupHour[i] - businessHour
                    if (diffHour[i] == 0 && diffMin[i] <= 15) {
                        return "ASAP ("+adjustedPickupTime[i].format("hh:mm a")+")"
                    }
                }
                if (adjustedPickupTime[i].isAfter(businessCloseTime[i]) || currentTime.isBefore(businessOpenTime[i])) {
                    adjustedPickupTime[i] = this.roundToNearest15Minute(adjustedPickupTime[i])
                    pickupMinute[i] = adjustedPickupTime[i].format("mm")
                    pickupHour[i] = adjustedPickupTime[i].format("HH")
                    businessMinute[i] = businessOpenTime[i].format("mm")
                    businessHour[i] = businessOpenTime[i].format("HH")
                    diffMin[i] = pickupMinute[i] - businessMinute[i]
                    diffHour[i] = pickupHour[i] - businessHour[i]
                    if (diffHour[i] == 0 && diffMin[i] <= 15) {
                        let placeHolderText = this.state.isAsap ? "ASAP (%time%)" : "%time%"
                        return placeHolderText.replace("%time%", formatTime(adjustedPickupTime[i]))
                        // return "ASAP ("+adjustedPickupTime[i].format("hh:mm a")+")"
                    }
                }
                if (this.state.isAsap && this.checkTimeWithinWorkingHour(currentTime, BUSINESS_OPEN_OFFSET, WorkingHourCheckingType.START_TIME)) {
                    adjustedPickupTime[i] = this.roundToNearest15Minute(adjustedPickupTime[i])
                    return "ASAP (" + formatTime(moment()) + ")"
                }

                if(moment().format("hh:mm:ss") < businessOpenTime[i] && this.state.defpickupTime == null){
                    return "----"
                }
                if(this.isPreOrderOnly() && this.state.defpickupTime == null){
                    return "-----"
                }
                return formatTime(this.state.pickupTime)
            })

            for (var i = 0; i < mapContainer.length; i++) {
                if(moment(adjustedPickupTime[i], "HH:mm").isBetween(moment(workingHours[i].start_time, "HH:mm"), moment(workingHours[i].end_time, "HH:mm"), null, '[]')) {
                    return mapContainer[i]
                }
            }
        } else {
                adjustedPickupTime = moment(this.state.pickupTime)
                businessOpenTime = moment(workingHours.start_time, "hh:mm:ss")
                businessCloseTime = moment(workingHours.end_time, "hh:mm:ss")
                adjustedPickupHour1 = adjustedPickupTime.format("HH")
                adjustedPickupMinute1 = adjustedPickupTime.format("mm")
                diffMin1 = adjustedPickupMinute1 - businessMinute1
                diffHour1 = adjustedPickupHour1 - businessHour1
                if(this.isBusinessClosed()){
                    return "--"
                }
                if( (this.isDelivery() && currentTime.isBefore(defaultDeliveryServiceTime) && this.state.defpickupTime == null) || diffHour1 == 0 && diffMin1 < 15 ) {
                    adjustedPickupTime = this.roundToNearest15Minute(defaultDeliveryServiceTime)
                    let pickupMinute = adjustedPickupTime.format("mm")
                    let pickupHour = adjustedPickupTime.format("HH")
                    let diffMin = pickupMinute - businessMinute
                    let diffHour = pickupHour - businessHour
                    if (diffHour == 0 && diffMin <= 15) {
                        return "ASAP ("+ formatTime(adjustedPickupTime) +")"
                    }
                }
                if (adjustedPickupTime.isAfter(businessCloseTime) || currentTime.isBefore(businessOpenTime)) {
                    adjustedPickupTime = this.roundToNearest15Minute(adjustedPickupTime)
                    let pickupMinute = parseInt(adjustedPickupTime.format("mm"))
                    let businessMinute = parseInt(businessOpenTime.format("mm"))
                    let pickupHour = parseInt(adjustedPickupTime.format("HH"))
                    let businessHour = parseInt(businessOpenTime.format("HH"))
                    let diffMin = pickupMinute - businessMinute
                    let diffHour = pickupHour - businessHour
                    if (diffHour == 0 && diffMin <= 15) {
                        let placeHolderText = this.state.isAsap ? "ASAP (%time%)" : "%time%"
                        return placeHolderText.replace("%time%", formatTime(adjustedPickupTime))
                        // return "ASAP ("+ formatTime(adjustedPickupTime) +")"
                    }
                }
                if (this.state.isAsap && !currentTime.isBefore(businessOpenTime)) {
                    adjustedPickupTime = this.roundToNearest15Minute(adjustedPickupTime)
                    return "ASAP ("+moment().format("hh:mm a")+")"
                }

                if(moment().format("hh:mm:ss") < businessOpenTime && this.state.defpickupTime == null){
                    return "----"
                }
                if(this.isPreOrderOnly() && this.state.defpickupTime == null){
                    return "-----"
                }
        }

        return this.state.defpickupTime ? this.state.defpickupTime : "-"
    }

    isToday = () => {
        return moment(this.state.pickupTime).isSame(moment(), 'day')
    }

    PromoModalonClose = () => {
        this.setState({showPromoModal: null})
    }
    isPickupOrDelivery = () => {
        return (this.props.app.state.table.table_type_bitwise & (TableType.BIT_PICKUP | TableType.BIT_DELIVERY)) > 0
    }
    getServiceChargePercent = () => {
        let scPercent = 0
        let serviceChargeGeneral = this.props.app.getMerchantSettingValue('service_charge')
        let serviceChargePickupDelivery = this.props.app.getMerchantSettingValue('service_charge_pickup_delivery')
        if (serviceChargePickupDelivery != null) {
            scPercent = serviceChargePickupDelivery
        }
        else if (serviceChargeGeneral != null) {
            scPercent = serviceChargeGeneral
        }
        return scPercent
    }
    isPickupAsapOrderOnly = () => {
        return this.getMerchantSettingValue('pickup_asap_order_only', false)
    }
    isDineInWithPayment = () => {
        return Table.isDineInWithPaymentTable()
    }
    onDineInTableChange = (dineInTable) => {
        this.setState({
            dineInTableId: dineInTable && dineInTable.value,
        })
    }
    promoCodeSection = () => {
        let scPercent = this.getServiceChargePercent()
        return <div style={{ padding: "10px", marginBottom: "20px", background: "white" }}>
            <div className="form-group row">
                <div className="col-sm-9">
                    <p><b>{lang.promo_code}</b></p>
                    <div style={{ display:"flex" }}>
                        {this.props.app.state.current_session.promo_code_data ?
                            <>
                            <div style={{ flex: "1 0 50px" }}>
                                <div style={{flex: "1 0 100px"}}>
                                    <div><strong>{this.props.app.state.current_session.promo_code_data.code}</strong></div>
                                    <div>{this.props.app.state.current_session.promo_code_data.description}</div>
                                </div>
                            </div>
                            <span className="fa fa-check-circle text-success" style={{ fontSize: "20pt", marginRight: "30vw", marginTop: "5px" }}></span>
                            <div style={{ flex: "1 0 50px", textAlign: "right" }}>
                                <button className="btn btn-default" onClick={() => this.setState({
                                    showPromoModal: <PromoCodeListModal
                                        pickupTime={this.state.pickupTime.toDate()}
                                        currencyName={this.props.currencyName}
                                        tableSession={this.props.app.state.current_session}
                                        selectedPromoCode={this.state.selectedPromoCode}
                                        setPromoCodeError={(msg) => this.setState({errorMessage: msg})}
                                        price={this.billCalculator.getBillDetail().total}
                                        data={this.props.app.state.promoData}
                                        app={this.props.app}
                                        onClose={this.PromoModalonClose}
                                        orders={this.props.app.state.orders}
                                        gotTax={this.props.app.state.merchant.tax_no}
                                        scPercent={scPercent}
                                        extraSCstart={this.props.app.getMerchantSettingValue('extra_service_charge_start')}
                                        extraSCend={this.props.app.getMerchantSettingValue('extra_service_charge_end')}
                                        extraSCName={this.props.app.getMerchantSettingValue('extra_service_charge_name') != null ? this.props.app.getMerchantSettingValue('extra_service_charge_name') : "Extra Surcharge"}
                                        extraSCPercent={this.props.app.getMerchantSettingValue('extra_service_charge_value')}
                                        deliveryCharge={this.isDelivery() && this.state.deliveryDetail && this.state.deliveryDetail.deliveryCharge || 0}
                                        />
                                        })}
                                        style={{
                                            width: "max-content",
                                        }}>
                                        Change
                                </button>
                            </div>
                            </> : <>
                            <div style={{ flex: "1 0 50px", fontSize: "14px" }}> Add a promo code for your meal </div>
                            <div style={{ flex: "1 0 50px", textAlign: "right" }}>
                                <button className="btn btn-success promo-find-here" onClick={() => this.setState({
                                    showPromoModal: <PromoCodeListModal
                                        currencyName={this.props.currencyName}
                                        tableSession={this.props.app.state.current_session}
                                        selectedPromoCode={this.state.selectedPromoCode}
                                        setPromoCodeError={(msg) => this.setState({errorMessage: msg})}
                                        price={this.billCalculator.getBillDetail().total}
                                        data={this.props.app.state.promoData}
                                        app={this.props.app}
                                        onClose={this.PromoModalonClose}
                                        orders={this.props.app.state.orders}
                                        gotTax={this.props.app.state.merchant.tax_no}
                                        scPercent={this.props.app.getMerchantSettingValue('service_charge')}
                                        extraSCstart={this.props.app.getMerchantSettingValue('extra_service_charge_start')}
                                        extraSCend={this.props.app.getMerchantSettingValue('extra_service_charge_end')}
                                        extraSCName={this.props.app.getMerchantSettingValue('extra_service_charge_name') != null ? this.props.app.getMerchantSettingValue('extra_service_charge_name') : "Extra Surcharge"}
                                        extraSCPercent={this.props.app.getMerchantSettingValue('extra_service_charge_value')}
                                        deliveryCharge={this.isDelivery() && this.state.deliveryDetail && this.state.deliveryDetail.deliveryCharge || 0}
                                        />
                                        })}
                                        style={{
                                            width: "max-content",
                                        }}>
                                        Find Here
                                </button>
                            </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    getMerchantOffDays = () => {
        return this.props.app.state.merchantOffDays
    }
    render() {
        const { merchant } = this.props.app.state
        const { current_session } = this.props.app.state
        const { disableRemark } = this.state
        if (!table_session_id) {
            pageReload.goTo(`/category/${this.props.match.params.tableQR}`)
        }
        if (this.state.counterRedirect == 1) {
            pageReload.goTo(`/category/${this.props.match.params.tableQR}`)
        }
        if (!this.props.app.isReadyFor(this)) {
            return (<div></div>);
        }

        let orderTotal = this.getDraftOrders().reduce((total, order) => {
            total += parseFloat(order.order_total)
            return total
        }, 0.00)

        let confirmOrderListing = <div id="tabConfirmed" className="tab-pane fade">
            <b style={{ margin: "5px", color: colorDanger }}><span>&#10033;</span>{lang.confirm_order_desc}</b>
            <ul className="list-group">{this.showConfirmOrderListing()}</ul>
        </div>

        let orderListing = this.renderOrderListing()

        let isDelivery = this.isDelivery()
        let minimumOrderValue = 1.00
        if (isDelivery) {
            minimumOrderValue = this.props.app.getMerchantSettingValue('delivery_minimum_order_value') || 10.00
        }
        else {
            minimumOrderValue = this.props.app.getMerchantSettingValue('pickup_minimum_order_value') || 1.00
        }

        minimumOrderValue = parseFloat(minimumOrderValue).toFixed(2)
        let subtotal = this.billCalculator.getBillDetail().subtotal
        let isLessThanMinimumAmount = subtotal < minimumOrderValue

        // Must be minimum RM1 to be able to proceed
        if (this.billCalculator.getTotalPrice() < 1) {
            isLessThanMinimumAmount = true
            minimumOrderValue = 1
        }

        const { table } = this.props.app.state
        let backLink = table && table.table_type_bitwise == 1 ? `/order/${this.props.match.params.tableQR}` : `/category/${this.props.match.params.tableQR}`

        const isHideDateTimePicker = (!this.isDelivery() && this.isPickupAsapOrderOnly()) || this.isDineInWithPayment()
        const isHidePromoCode = this.getMerchantSettingValue('hide_promo_code_section', false)
        return (
            <div>
                <TopNav
                    tableQR={this.props.match.params.tableQR}
                    title={lang.order}
                    table={this.props.app.state.table}
                    backButton={this.props.app.state.current_session && !this.props.app.state.current_session.is_pickup_confirmed}
                    backLabel={lang.back}
                    back={backLink}
                />
                {
                    this.state.editingMenuItem == null ? '' :
                        <MenuItemModal
                            app={this.props.app}
                            isPickupOrDelivery={this.isPickupOrDelivery()}
                            menuItem={this.state.editingMenuItem}
                            order={this.state.editingOrder}
                            onCancelOrder={this.fireCancelOrderApi}
                            onClose={() => { this.setState({ editingMenuItem: null, editingOrder: null }) }}
                        />
                }
                {this.state.showPromoModal}
                {this.state.timePickerModal}
                {this.state.changeOrderModeModal}
                {this.state.changePickupOrderModeModal}
                {this.state.confirmModal}
                {this.state.confirmNewModal}
                {this.state.paymentMethodModal}
                {this.state.errorMessage && <MessageModal message={this.state.errorMessage} onClose={() => this.setState({ errorMessage: null }, this.state.errorMsgOnClose)} />}

                {this.error && <div className='alert alert-danger' style={{ padding: '10px', margin: "60px 10px 10px 10px" }}>
                    {lang.payment_failure.replace('{error}', this.error)}
                </div>}
                {
                    this.isShowOrderListing() &&
                    <div className='col-sm-12'>
                        <div style={{ padding: '50px 10px 10px 10px', marginBottom: "10px", backgroundColor: "white" }}>
                            <h3>{lang.review_order}</h3>
                            <div id="tabDraft" className="tab-pane fade in active">
                                <b style={{ margin: "5px", color: colorDanger }}><span>&#10033;</span>{lang.draft_order_desc}</b>
                                <ul className="list-group">{this.showDraftOrderListing()}</ul>
                            </div>
                            {/* {confirmOrderListing} */}
                        </div>
                        {
                            !customerId ?
                                (<div className="mt-1 mb-5">
                                    <button className="btn btn-primary" onClick={this.showLoginModal}>{lang.login_to_continue}</button>
                                </div>) :

                                <>
                                    {
                                        this.isDineInWithPayment() ?
                                        <SelectDineInTable
                                            isNeedHighlight={this.state.highlightSelectTableCard}
                                            onDineInTableChange={this.onDineInTableChange}
                                            app={this.props.app}
                                            onChangePickupOrderModeClicked={this.onChangePickupOrderModeClicked}
                                            setPickupOrderMode={this.setPickupOrderMode}
                                            onChangeOrderModeClicked={this.onChangeOrderModeClicked}
                                        /> :
                                        <ChangeModeSelect
                                            app={this.props.app}
                                            onChangeOrderModeClicked={this.onChangeOrderModeClicked}
                                            onChangePickupOrderModeClicked={this.onChangePickupOrderModeClicked}
                                            getPickupOrderModes={this.getPickupOrderModes}
                                            pickupOrderMode={this.state.pickupOrderMode}
                                            isUpdatingPickupOrderMode={this.state.isUpdatingPickupOrderMode}
                                            setPickupOrderMode={this.setPickupOrderMode} />
                                    }

                                    {
                                        !isHideDateTimePicker &&
                                        <ChoosePickupTime {...this} app={this.props.app} />
                                    }

                                    {
                                        isDelivery &&
                                        <DeliveryAddress onChangeAddressClicked={this.onChangeAddressClicked} currencyName={this.props.currencyName} deliveryDetail={this.state.deliveryDetail} deliveryInfo={this.state.deliveryInfo} billCalculator={this.billCalculator} isCalculatingDeliveryCharge={this.state.isCalculatingDeliveryCharge} multiTierDeliveryDiscount={this.state.multiTierDeliveryDiscount} />
                                    }
                                    {
                                        !isHidePromoCode &&
                                        this.promoCodeSection()
                                    }
                                    <ContactInformation
                                        contact={this.state.contact}
                                        currencyName={this.props.currencyName}
                                        merchant={merchant}
                                        onSubmit={this.onSubmit}
                                        isAllowSubmit={!(isLessThanMinimumAmount || !this.state.pickupTime || this.state.isUpdatingPickupOrderMode || this.state.isCalculatingDeliveryCharge || this.isBusinessClosed() || this.state.outOfStockItems.length > 0)}
                                        isShowLoading={this.state.isUpdatingPickupOrderMode || this.state.isCalculatingDeliveryCharge}
                                        buttonDisabledHint={this.isBusinessClosed() ? this.getBusinessClosedReason() : ""}
                                        isLessThanMinimumAmount={isLessThanMinimumAmount}
                                        minimumOrderValue={minimumOrderValue}
                                        remark={{
                                            placeholder: lang.car_plate_number,
                                            label: lang.remark,
                                            disabled: disableRemark,
                                        }}
                                        isAllowDriveThrough={!isDelivery && this.props.app.isMerchantHasFeature('is_allow_drive_through')}
                                        isDeliveryPeakHour={this.isDelivery() && this.state.isPeakHour}
                                        isOutOfStockHint={this.state.outOfStockItems.length > 0 && lang.some_item_out_of_stock}
                                    />
                                </>
                        }
                    </div>
                }
                {
                    this.isShowQueueNumber() &&
                    <div>
                        <div className='col-sm-12' style={{ padding: '50px 10px 10px 10px', marginBottom: "10px", backgroundColor: "white" }}>
                            <h4 style={{ textAlign: 'center' }}>{lang.your_order_number}</h4>
                            <br />
                            <h1 style={{ margin: 'auto', textAlign: 'center', padding: '10px', border: '1px solid black', maxWidth: '200px', borderRadius: '5px' }}>{this.props.app.state.current_session.queue_number}</h1>
                            <br />
                            <h4 style={{ textAlign: 'center' }}>{lang.wait_for_order}</h4>
                            <br />
                            {this.props.app.state.merchant && this.props.app.state.merchant.is_payment_gateway_enabled && <p className='text-center'><button className="btn btn-success" style={{ fontSize: '24px', textTransform: 'uppercase' }} onClick={() => this.payNoPrompt()}>{lang.pay_now}</button></p>}
                            {this.props.app.state.merchant && this.props.app.state.merchant.is_payment_gateway_enabled && <br />}
                            <p className='text-center'><button className="btn btn-primary" onClick={() => this.onRestartOrder()}>{lang.order_again}</button></p>
                        </div>
                    </div>
                }
                {
                    this.isShowWaitingForPaymentHint() &&
                    this.renderWaitingForPayment(orderListing)
                }
                {this.state.firebaseLoginModal}
            </div>
        )
    }
    onCheckPaymentClicked = () => {
        this.setState({
            isCheckingPayment: true
        })
        this.fireCheckPaymentApi()
        setTimeout(() => {
            this.setState({
                isCheckingPayment: false
            })
        }, 10000);
    }
    checkPaymentButton = () => {
        const { hasPendingPayment, isCheckingPayment, allowShowCheckPaymentButton } = this.state
        if (hasPendingPayment && allowShowCheckPaymentButton && this.props.app.state.table_session) {
            return <button disabled={isCheckingPayment} className="btn btn-sm btn-secondary" onClick={this.onCheckPaymentClicked}>
                {lang.check_payment} {isCheckingPayment && <span><i className="fa fa-spinner fa-spin" /></span>}
            </button>
        }
        return null
    }
    renderWaitingForPayment = (orderListing) => {
        return <div>
            <div className='col-sm-12' style={{ padding: '50px 10px 10px 10px', marginBottom: "10px", backgroundColor: "white" }}>
                <h4 style={{ textAlign: 'center' }}>{lang.make_payment_hint}</h4>
                <br />
                {
                    this.props.app.state.merchant &&
                    this.props.app.state.merchant.is_payment_gateway_enabled &&
                    <>
                        <div style={{ textAlign: "center" }}>
                            <div style={{ fontSize: "14pt" }}>
                                {lang.total}
                            </div>
                            <div style={{ fontSize: "20pt", fontWeight: "bold", lineHeight: "0.9" }}>
                                {this.props.currencyName}&nbsp; {this.billCalculator.getTotalPrice().toFixed(2)}
                            </div>
                        </div>
                        <p className="text-center mt-5">
                            <button className="btn btn-success" style={{ fontSize: '24px', textTransform: 'uppercase' }} onClick={() => this.payNoPrompt()}>
                                {lang.pay_now}
                            </button>
                        </p>
                        <p className="text-center mt-2">
                            {this.checkPaymentButton()}
                        </p>
                    </>
                }
                {this.props.app.state.merchant && this.props.app.state.merchant.is_payment_gateway_enabled && <br />}
                {/* <p className='text-center'><button className="btn btn-primary" onClick={() => this.onRestartOrder()}>{lang.order_again}</button></p> */}
            </div>
            {orderListing}
            {
                this.state.deliveryDetail &&
                <DeliveryAddress onChangeAddressClicked={null} deliveryDetail={this.state.deliveryDetail} isLargeFont deliveryInfo={this.state.deliveryInfo} billCalculator={this.billCalculator} currencyName={this.props.currencyName} />
            }
            <div style={{ padding: "10px" }}>
                <button className="btn btn-danger" onClick={this.onCancelOrder}>{lang.cancel_order}</button>
            </div>
        </div>
    }

    isShowOrderListing = () => {
        return this.props.app.state.current_session &&
            !this.props.app.state.current_session.is_pickup_confirmed   // Order is draft and not confirmed
    }

    isShowQueueNumber = () => {
        const result = this.props.app.state.current_session &&
            this.props.app.state.current_session.is_pickup_confirmed && // User confirmed the orders
            this.props.app.state.current_session.bill_id                // Bill created and payment done
        return result
    }

    isShowWaitingForPaymentHint = () => {
        const result = this.props.app.state.current_session &&
            this.props.app.state.current_session.is_pickup_confirmed && // User confirmed the orders
            this.props.app.state.current_session.bill_id == null        // No bill = no payment
        return result
    }

    showLoginModal = () => {
        this.setState({
            firebaseLoginModal: <LoginModal
                app={this.props.app}
                onLoginSuccess={(customerData) => {
                    this.setState({ firebaseLoginModal: null, contact: customerData })
                }}
                onClose={() => this.setState({ firebaseLoginModal: null })}
            />
        })
    }
}

function PromoCodeCard({ app, tableSession, onChangeOrderModeClicked, setPromoCodeError, showPromoModal, selectedPromoCode }) {
    const [promoCodeStr, setPromoCodeStr] = useState("")
    const [isCheckingPromoCode, setIsCheckingPromoCode] = useState(false)
    const checkPromoCode = () => {
        setIsCheckingPromoCode(true)
        $.ajax({
            url     : `/table_sessions/${tableSession.id}/use_promo_code/${promoCodeStr}`,
            type    : 'post',
            success : (res) => {
                if (res) {
                    setPromoCodeStr("")
                }
            }
        })
        .fail(handlePromoCodeError)
        .always(() => {
            setIsCheckingPromoCode(false)
        })
    }

    const handlePromoCodeError = (xhr) => {
        if(xhr.responseJSON && xhr.responseJSON.message){
            if (setPromoCodeError) {
                setPromoCodeError(xhr.responseJSON.message)
            }
            else {
                alert(xhr.responseJSON.message)
            }
        }
        return false
    }

    return <div style={{ padding: '10px', marginBottom: "20px", backgroundColor: "white" }}>
        <div className="form-group row">
            <label htmlFor="order-type" className="col-sm-3 col-form-label">{lang.promo_code}</label>
            <div className="col-sm-9">
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "1 0 50px" }}>
                        <input type="text" className="form-control" onClick={showPromoModal} value={promoCodeStr} onChange={(e) => setPromoCodeStr(e.target.value)}/>
                    </div>
                    {
                        <div style={{ flex: "1 0 50px", textAlign: "right" }}>
                            <button className="btn btn-default" onClick={checkPromoCode} disabled={isCheckingPromoCode || !promoCodeStr}>
                                {
                                    isCheckingPromoCode ?
                                    <span className="fa fa-spinner fa-spin"></span> :
                                    <span>Use Code</span>
                                }
                            </button>
                        </div>
                    }
                </div>
                {
                    tableSession.promo_code_data &&
                    <div className="mt-5" style={{display:"flex"}}>
                        <div style={{flex: "1 0 100px"}}>
                            <div><strong>{tableSession.promo_code_data.code}</strong></div>
                            <div>{tableSession.promo_code_data.description}</div>
                        </div>
                        <div style={{margin: "auto"}}>
                            <span className="fa fa-check-circle text-success ml-2" style={{fontSize: "20pt"}}></span>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}

function SelectDineInTable({ app, onDineInTableChange, isNeedHighlight, }) {
    const bordersAndPadding = !isNeedHighlight ? {} : {
        padding: "8px",
        margin: "-8px",
        border: `2px solid ${colorDanger}`,
        borderRadius: "8px",
    }
    // const bordersAndPadding = {
    //     padding: "8px",
    //     margin: "-8px",
    //     border: `2px solid ${colorDanger}`,
    //     borderRadius: "8px",
    // }
    return <div style={{ marginBottom: "20px"}}>
        <div style={{ ...bordersAndPadding}}>
            <div id="select-dine-in-table" style={{ padding: '10px', backgroundColor: "white", }}>
                <div className="form-group row">
                    <label htmlFor="order-type" className="col-sm-3 col-form-label">{lang.select_table}</label>
                    <div className="col-sm-9">
                        <div style={{ display: "flex" }}>
                            <TableSearchComponent
                                placeholder={"Please select your table"}
                                blurInputOnSelect={true}
                                onChange={onDineInTableChange}
                                app={app}
                                isClearable={false}
                                merchantId={app.state.table.merchant_id}
                                hideProceedButton={true}
                                type={"pick-up-table"}
                                pickupTableId={app.state.table.id}
                            />
                            {/* <ChangeOrderMode onChangePickupOrderModeClicked={onChangePickupOrderModeClicked} setPickupOrderMode={setPickupOrderMode} /> : */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

// Will use this value temporarily while waiting for API result
let _tempPickupOrderMode = null
function ChangeModeSelect({ app, onChangeOrderModeClicked, onChangePickupOrderModeClicked, getPickupOrderModes, pickupOrderMode, isUpdatingPickupOrderMode, setPickupOrderMode, }) {
    const table = app.state.table
    const isBothPickupAndDelivery = table.pickup && table.delivery
    const isDelivery = OrderHandler.getTableSessionType() == TableSessionType.DELIVERY
    const pickupOrderModes = getPickupOrderModes && getPickupOrderModes() || []

    let orderMode = isDelivery ? lang.delivery : lang.pickup
    if (!isDelivery && pickupOrderModes.length && pickupOrderMode) {
        orderMode = pickupOrderMode
    }

    const displayOrderModeText = () => {
        return <div style={{ flex: "1 0 50px" }}>
            {orderMode}
        </div>
    }

    // We will decide which radio button is checked by following priority
    // 1.  Not waiting for API result (already confirmed by API)
    //      i.   pickupOrderMode - Always use 'pickupOrderMode', the final result as stored in DB
    // 2.  Waiting for API result (not confirmed by API yet)
    //      i.   _tempPickupOrderMode   - Use the value selected by user, while we are waiting for confirmation from API
    //      ii.  pickupOrderMode        - Fallback to use the value provided by DB, if _tempPickupOrderMode is not set,
    //                                    ie. user had not interact with the radio buttons yet
    const checkedPickupOrderMode = isUpdatingPickupOrderMode ? (_tempPickupOrderMode || pickupOrderMode) : pickupOrderMode

    const updatePickupOrderMode = (option) => {
        _tempPickupOrderMode = option
        setPickupOrderMode(option)
    }
    const currencyName = app.state.currencyName || ""
    const displayOrderModeRadioButtons = () => {
        return <div style={{ flex: "1 0 50px", display: "flex" }} disabled={!!isUpdatingPickupOrderMode}>
            <div style={{}}>
                {
                    pickupOrderModes.map(option => {
                        const extraCharge = PickupOrderMode.getPickupOrderModesExtraCharge(option)
                        const extraChargeText = extraCharge ? `(${lang.extra_charge} ${currencyName}${extraCharge.toFixed(2)})` : ""
                        return <div key={option}>
                            <label>
                                <span style={{width: "10px"}}>
                                    <input
                                        disabled={!!isUpdatingPickupOrderMode}
                                        name="pickupOrderMode" type="radio"
                                        value={option}
                                        checked={option === checkedPickupOrderMode}
                                        onChange={() => updatePickupOrderMode(option)} />
                                </span>
                                <span className="ml-2">{option} {extraChargeText}</span>
                            </label>
                        </div>
                    })
                }
            </div>
            <div style={{flex: "1 0 100px", textAlign: "left", margin: "auto", paddingLeft: "20px"}}>
                {
                    isUpdatingPickupOrderMode ?
                    <PulseLoader className="" color="#ffa733" size="10px" margin="4px" /> :
                    null
                }
            </div>
        </div>
    }

    const popUpModalMode = PickupOrderMode.changeModeMethod() == PickupOrderModeChangeModeMethod.Modal
    const labelTitle = lang.order_type
    return <div style={{ padding: '10px', marginBottom: "20px", backgroundColor: "white" }}>
        <div className="form-group row">
            <label htmlFor="order-type" className="col-sm-3 col-form-label">{labelTitle}</label>
            <div className="col-sm-9">
                <div style={{ display: "flex" }}>
                    {
                        isDelivery ?
                        displayOrderModeText() :
                        (
                            popUpModalMode ?
                            displayOrderModeText() :
                            displayOrderModeRadioButtons()
                        )
                    }
                    {
                        isBothPickupAndDelivery &&
                        <div style={{ flex: "1 0 50px", textAlign: "right" }}>
                            <button className="btn btn-default" onClick={onChangeOrderModeClicked}>{lang.change}</button>
                        </div>
                    }
                    {
                        table.pickup && pickupOrderModes.length > 1 &&
                        (
                            popUpModalMode ?
                            <ChangeOrderMode isUpdatingPickupOrderMode={isUpdatingPickupOrderMode} onChangePickupOrderModeClicked={onChangePickupOrderModeClicked} setPickupOrderMode={setPickupOrderMode} /> :
                            null
                        )
                    }
                </div>
            </div>
        </div>
    </div>
}

class ChangeOrderMode extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        const { isUpdatingPickupOrderMode, onChangePickupOrderModeClicked } = this.props
        return (
            <div style={{ flex: "1 0 50px", textAlign: "right" }}>
                <button disabled={!!isUpdatingPickupOrderMode} className="btn btn-default" onClick={!!isUpdatingPickupOrderMode ? null : onChangePickupOrderModeClicked}>
                    {lang.change} {!!isUpdatingPickupOrderMode && <i className="fa fa-spinner fa-spin" />}
                </button>
            </div>
        )
    }
}

export function buildFullAddress(deliveryDetail) {
    let streetNumber = deliveryDetail.streetNumber
    return (streetNumber ? streetNumber + ", " : "") + (deliveryDetail.addressComponents || []).join("")
}


// don't remove, important for datepicker
class PreOrderButton extends Component {
    render() {
        const { value, onClick } = this.props
        return (
            <button onClick={onClick} style={{ display: "none" }}>{value}</button>
        )
    }
}

function DeliveryAddress({ billCalculator, onChangeAddressClicked, deliveryDetail, deliveryDetail: { deliveryCharge, addressComponents, peakHourSurcharge }, isLargeFont, deliveryInfo, currencyName, isCalculatingDeliveryCharge, multiTierDeliveryDiscount }) {
    if (!deliveryDetail) {
        return null
    }

    let fontSize = isLargeFont ? "20px" : "14pt"
    let streetNumber = OrderHandler.getDeliveryStreetNumber()

    let deliveryCharge_text = "";
    let deliveryCharge_slashText = "";
    let description_text = ""
    let finalCost = 0
    let peakHourSurchargeStr = ""
    if (deliveryCharge == 0) {
        deliveryCharge_text = lang.free_delivery

        if (multiTierDeliveryDiscount && multiTierDeliveryDiscount.originalDeliveryPrice) {
            deliveryCharge_slashText = currencyName + " " + parseFloat(multiTierDeliveryDiscount.originalDeliveryPrice).toFixed(2)
        }
    }
    else {
        const promoCodeDeliveryDiscount = parseFloat(billCalculator.getBillDetail().promo_code_delivery_discount || 0)
        if (promoCodeDeliveryDiscount) {
            deliveryCharge_slashText = currencyName + " " + parseFloat(deliveryCharge).toFixed(2)
        }
        else if (multiTierDeliveryDiscount && multiTierDeliveryDiscount.originalDeliveryPrice) {
            deliveryCharge_slashText = currencyName + " " + parseFloat(multiTierDeliveryDiscount.originalDeliveryPrice).toFixed(2)
        }
        deliveryCharge_text = currencyName+" "+ (parseFloat(deliveryCharge) - promoCodeDeliveryDiscount).toFixed(2)

        if (peakHourSurcharge > 0) {
            const baseDeliveryCharge = deliveryCharge - peakHourSurcharge
            peakHourSurchargeStr = <span>
                ({lang.base_charge}: <strong>{currencyName}&nbsp; {baseDeliveryCharge.toFixed(2)}</strong>, {lang.peak_hour_surcharge}: <strong>{currencyName}&nbsp; {peakHourSurcharge.toFixed(2)}</strong>)
            </span>
        }
        description_text = deliveryInfo.description
    }

    let reason_text = ""
    if (deliveryInfo.reason && deliveryInfo.reason != "") {
        reason_text = "(" + deliveryInfo.reason + ")";
    }

    return <div style={{ padding: '10px', marginBottom: "20px", backgroundColor: "white" }}>
        <div className="form-group row">
            <label htmlFor="address" className="col-sm-3 col-form-label">{lang.delivery_address}</label>
            <div className="col-sm-9">
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "1 0 50px", fontSize: fontSize }}>
                        {
                            addressComponents.map((component, index) => {
                                if (component) {
                                    return <div key={index} style={{ padding: "2px 5px" }}>
                                        {index == 0 && streetNumber ? streetNumber + ", " : ""}
                                        {component}
                                    </div>
                                }
                            })
                        }
                    </div>
                    {
                        onChangeAddressClicked &&
                        <div style={{ flex: "1 0 50px", textAlign: "right" }}>
                            <button className="btn btn-default" onClick={onChangeAddressClicked}>{lang.change_address}</button>
                        </div>
                    }
                </div>
            </div>
        </div>

        <div className="form-group row">
            <label htmlFor="delivery-charge" className="col-sm-3 col-form-label">{lang.delivery_charge}</label>
            {
                isCalculatingDeliveryCharge ?
                    <PulseLoader className="" color="#ffa733" size="10px" margin="4px" /> :
                    <div className="col-sm-9 col-form-label" style={{ fontSize: fontSize }}>
                        {
                            deliveryCharge_slashText &&
                            <span className="text-danger" style={{ fontSize: "80%", fontWeight: "bold", textDecoration: "line-through", marginRight: "10px" }}>{deliveryCharge_slashText}</span>
                        }
                        <span style={{ fontWeight: "bold" }}>{deliveryCharge_text}</span>
                        <span style={{ color: "darkred", fontWeight: "bold", marginLeft: "5px" }}>{reason_text}</span>
                        <div style={{ fontSize: "10pt" }}>
                            <span style={{ color: "red" }}>{description_text}</span>
                        </div>
                        {
                            peakHourSurchargeStr &&
                            <span style={{fontSize: "70%"}}>{peakHourSurchargeStr}</span>
                        }
                    </div>
            }
        </div>
    </div>
}

function ContactInformation({ contact, contact: { }, merchant, onSubmit, isAllowSubmit, isShowLoading, isLessThanMinimumAmount, minimumOrderValue, remark, isAllowDriveThrough, buttonDisabledHint, currencyName, isDeliveryPeakHour, isOutOfStockHint }) {
    let initalValues = { ...contact }
    if (isAllowDriveThrough) {
        initalValues.is_drive_through = false
        initalValues.car_plate_number = ''
    }
    return <div style={{ padding: '10px', marginBottom: "20px", backgroundColor: "white" }}>
        <h3>{lang.enter_contact_information}</h3>
        <Formik
            initialValues={initalValues}
            validationSchema={
                Yup.object().shape({
                    name: Yup.string().required('Name is required.'),
                    phone_number: Yup.string().required('Phone Number is required.'),
                    is_drive_through: Yup.boolean(),
                    car_plate_number: Yup.string().when('is_drive_through', {
                        is: true,
                        then: Yup.string().required('Car plate number is required'),
                        otherwise: Yup.string()
                    })
                })
            }
            enableReinitialize={true}
            onSubmit={(values, actions) => {
                onSubmit(values, actions)
            }}>
            {({
                handleSubmit,
                isSubmitting, values }) => {
                const emailHint = !values.email && "* " + lang.fill_in_email_for_ewallet

                const isDisableSubmitButton = isSubmitting || !isAllowSubmit
                return <Form onSubmit={handleSubmit}>
                    <TextInput name='name' label={`${lang.name} *`} />
                    <TextInput name='phone_number' label={`${lang.phone_number} *`} />
                    <TextInput name='email' label={`${lang.email}`} hint={emailHint} />
                    <HiddenInput name='firebase_uid' />

                    {
                        isAllowDriveThrough &&
                        <>
                            <SwitchInput name="is_drive_through" label={lang.is_send_to_car} />
                            {
                                values.is_drive_through &&
                                <TextInput name='car_plate_number' label={`${lang.car_plate_number} *`} />
                            }
                        </>
                    }

                    {
                        remark && !remark.disabled &&
                        <TextInput name='remark' label={`${remark.label}`} />
                    }

                    {
                        isLessThanMinimumAmount &&
                        <div className="mb-1" style={{ color: "red" }}>{lang.minimum_order_amount_hint.replace('%d', currencyName).replace('%s', minimumOrderValue)}</div>
                    }
                    <button id="btn-confirm-and-pay" className="btn btn-primary" type="submit" disabled={isDisableSubmitButton}>
                        {merchant.is_payment_gateway_enabled && lang.confirm_and_pay || lang.submit} {isShowLoading && <i className="fa fa-spinner fa-spin"/>}
                    </button>
                    {
                        buttonDisabledHint && <div style={{color:"red"}} className="mt-2">{buttonDisabledHint}</div>
                    }
                    {
                        isAllowSubmit && isDeliveryPeakHour &&
                        <div className="mt-2">
                            <span style={{ color: "darkred", fontWeight: "bold" }}>{lang.peak_hour_hint}</span>
                        </div>
                    }
                    {
                        isOutOfStockHint && <div style={{color:"red"}} className="mt-2">{isOutOfStockHint}</div>
                    }
                </Form>
            }
            }
        </Formik>
    </div>
}

class ChoosePickupTime extends Component {
    constructor(props) {
        super(props)
    }
    getPeakHoursAsString = () => {
        return AppData.getPeakHoursAsString(this.props.state.appSettings)
    }
    render() {
        let foodDeliverTime = !!parseInt(this.props.app.getMerchantSettingValue('is_do_not_allow_choose_delivery_time'))
        let isDoNotAllowChooseDeliveryTime = this.props.isDoNotAllowChooseDeliveryTime()
        let preOrderDayCount = this.props.app.getMerchantSettingValue('pre_order_day_count') || 3
        let dateNum = this.props.app.getMerchantSettingValue('is_do_not_allow_pre_order') != 0 && this.props.app.getMerchantSettingValue('is_do_not_allow_pre_order') != null ? new Date() : addDays(new Date(), preOrderDayCount)

        let businessClosedDays = this.props.getBusinessClosedDays()
        const merchantMenu = this.props.getMerchantMenu()
        const { menuStartTime, menuEndTime } = this.props.getMerchantMenuTime()
        let _menuAvailableDayMap = {}

        const filterPreOrderDate = (date) => {
            // The list of filter functions to be run. If any function return false,
            // the will return false for 'filterPreOrderDate' and skip further checking
            const filterFunctions = [
                this.props.merchantOffDayFilter,
                historicDateFilter,
                businessClosedDaysFilter,
                merchantMenuDateFilter,
            ]

            const funcCount = filterFunctions.length
            for (let i = 0; i < funcCount; i++) {
                const func = filterFunctions[i]
                if (!func(moment(date))) {
                    // Hide this date if it fail any of the filter functions
                    return false
                }
            }
            return true
        }
        const today = moment()
        const historicDateFilter = (momentDate) => {
            // Filter historic days
            let businessDay = momentDate
            let isFuture = this.props.isPreOrderOnly() ? businessDay.isAfter(today, 'day') : businessDay.isSameOrAfter(today, 'day')
            if (!isFuture) {
                return false
            }
            return true
        }
        const businessClosedDaysFilter = (momentDate) => {
            // Filter business not opened days
            if (businessClosedDays.indexOf(momentDate.format('ddd')) !== -1) {
                return false
            }
            return true
        }
        const merchantMenuDateFilter = (momentDate) => {
            let businessDay = momentDate
            // Filter days that has odd working hours, which results in selected menu not avaiable on
            // that day
            if (merchantMenu && menuStartTime && menuEndTime) {
                let day = businessDay.isSame(today, 'day') ? "today" : businessDay.get('day')
                if (typeof _menuAvailableDayMap[day] === 'undefined') {
                    const { isMenuNotInBusinessHour } =  this.props.getBusinessOpenAndCloseTime(businessDay)
                    _menuAvailableDayMap[day] = isMenuNotInBusinessHour
                }
                if (_menuAvailableDayMap[day]) {
                    return false
                }
            }
            return true
        }
        return <div style={{ padding: '10px', marginBottom: "20px", backgroundColor: "white" }}>
            <span style={{ color: "darkred", fontWeight: "bold" }}>{this.props.state.pickupTimeError}</span>
            {
                this.props.isDelivery() && !this.props.isBusinessClosed() &&
                <span style={{ color: "darkred", fontWeight: "bold" }}>{isDoNotAllowChooseDeliveryTime ? "" : (this.props.state.isPeakHour ? lang.peak_hour_hint : "") }</span>
            }

            <div className="form-group row">
                <label htmlFor="pickup-time" className="col-sm-3 col-form-label">
                    <div style={{display: "flex"}}>
                        <div>
                            {this.props.isDelivery() ? (isDoNotAllowChooseDeliveryTime ? lang.delivery_date : lang.delivery_time) : lang.pickup_time} *
                            {foodDeliverTime ? "" :
                                <p style={{color: "red", fontSize: "10px"}}>
                                    <i>{lang.food_done_note}
                                        <b>{this.props.app.getMerchantSettingValue('food_done_note_time') || "30 - 45 Minutes"}
                                            {
                                                lang.food_done_note2 && <span><br/>{lang.food_done_note2}</span>
                                            }
                                        </b>
                                    </i>
                                </p>
                            }
                        </div>
                    </div>
                </label>
                <div className="col-sm-9" style={{ marginBottom: "5px" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: "1 0 100px", display: "flex"}} className="form-control mr-2" onClick={this.props.openDatePicker}>
                            <span style={{flex: "1 0 70px"}}>
                                {this.props.state.pickupTime && this.props.isToday() ? lang.today : this.props.toDateDayString(this.props.state.pickupTime)}
                            </span>
                            <span className="caret" style={{margin:"auto"}}></span>
                        </div>
                        {
                            !isDoNotAllowChooseDeliveryTime &&
                            <div style={{border:"1px solid #ccd0d2", flex: "1 0 70px", display:"flex"}} className="form-control">
                                <span style={{flex: "1 0 70px"}} onClick={this.props.showTimePicker}>
                                    {this.props.nowAvailability()}
                                </span>
                                <span className="caret" style={{margin:"auto"}}></span>
                            </div>
                        }

                        {/* Dont simply adjust this date picker position */}
                        <DatePicker
                            showPopperArrow={false}
                            todayButton={!this.props.isPreOrderOnly() && lang.today}
                            selected={this.props.state.pickupTime.toDate()}
                            onChange={this.props.handleChange}
                            open={this.props.state.datePickerIsOpen}
                            onClickOutside={this.props.openDatePicker}
                            onSelect={this.props.openDatePicker}
                            dateFormat="yyyy-MM-dd"
                            maxDate={dateNum}
                            shouldCloseOnSelect={true}
                            filterDate={filterPreOrderDate}
                            withPortal
                            ref={this.props.datePickerRef}
                            customInput={<PreOrderButton />}
                        />
                    </div>
                    <div className="col-sm-9">
                        {!this.props.state.pickupTime && <div className='text-danger'>{lang.pickup_time_required}</div>}
                    </div>
                </div>

                {
                    !isDoNotAllowChooseDeliveryTime &&
                    <div className="col-sm-9">
                        {!this.props.state.pickupTime && <div className='text-danger'>{lang.pickup_time_required}</div>}
                        {
                            this.props.state.isPeakHour && this.props.isDelivery() && !this.props.isBusinessClosed() &&
                            <div className="mt-2">
                                {lang.peak_hour}
                                {
                                    this.getPeakHoursAsString().map((str, index) => {
                                    return <div key={index}>{str}</div>
                                    })
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
}